import React, { useState, useEffect, useRef } from 'react';
import './CSS/eLearnCSS.css';
import MasterBKG from './Common/Images/MasterBKG.png';
import SysAdminBkg from './Common/Images/SysAdminBkg.gif';
import { useNavigate } from 'react-router-dom';
import popup_bg1 from './Common/Images/ImagesForAlert/popup_bg1.png';
import CustomAlert from './Common/CustomAlert';
import CustomConfirmation from './Common/CustomConfirmation';
import Loading from './Common/Loading';
import KMDistributorSalesReport from './WEBADMIN/REPORTS/KMDistributorSalesReport';
import EL_SchoolUsage from './WEBADMIN/REPORTS/EL_SchoolUsage';
import EL_LoginUsage from './WEBADMIN/REPORTS/EL_LoginUsage';
import EL_AddDNCNumbers from './SUPPORT/EL_AddDNCNumbers';
import EL_ShowUpdates from './WEBADMIN/ADMIN/EL_ShowUpdates';


interface School {
  code: string;
  name: string;
  status: string;
  maxUsers: string;
  maxSeats: string;
  admins: string;
  regFamilies: string;
  regTeachers: string;
  regUsers: string;
  eligibleForIncentives: string;
  dlrOrHO: string;
  category: string;
}

interface SchoolAPI {
  schoolcode: string;
  name: string;
  address: string;
  country: string;
  category: string;
  status: string;
  maxusers: number;
  maxseats: number;
}

interface Login {
  login: string;
  password: string;
  name: string;
  category: string;
  status: string;
  validity: string;
  mdsAvail: string;
  mdsUsed: string;
  std: string;
  points: string;
  incentives: string;
  howAdded: string;
}

interface MDReport {
  reportno: number,
  testcompletiondate: string,
  studyyear: number,
  score: number
}

interface ECReport {
  reportno: number;
  testcompletiondate: string;
  studyyear: number;
  score: number;
}


type MenuItem = {
  code?: string;
  label: string;
  group?: string;
  danger?: boolean;
  navigation?: string;
  status?: string;
};

type MenuMap = Record<string, MenuItem[]>;

const SysAdmin: React.FC = () => {
  const [siteMode, setSiteMode] = useState<string>('');
  const [countries, setCountries] = useState<string[]>([]);
  const [selectedCountry, setSelectedCountry] = useState<string>('');
  const [schoolType, setSchoolType] = useState<string>('SCH');
  const [schools, setSchools] = useState<School[]>([]);
  const [selectedSchool, setSelectedSchool] = useState<School | null>(null);
  const [apiSchools, setApiSchools] = useState<SchoolAPI[]>([]);
  const [admins, setAdmins] = useState<Login[]>([]);
  const [families, setFamilies] = useState<Login[]>([]);
  const [teachers, setTeachers] = useState<Login[]>([]);
  const [students, setStudents] = useState<Login[]>([]);
  const [children, setChildren] = useState<Login[]>([]);
  const [mdReports, setMdReports] = useState<MDReport[]>([]);
  const [ecReports, setEcReports] = useState<ECReport[]>([]);
  const [selectedMDReport, setSelectedMDReport] = useState<string>('');
  const [selectedECReport, setSelectedECReport] = useState<string>('');
  // const [selectedReport, setSelectedReport] = useState<string>(sessionStorage.getItem('ReportNo') || '');
  const [selectedReport, setSelectedReport] = useState<string>('');
  const [selectedLogin, setSelectedLogin] = useState<Login | null>(null);
  const [selectedFamily, setSelectedFamily] = useState<string>('');
  const [selectedChild, setSelectedChild] = useState<string>('');
  const [selectedChildLogin, setSelectedChildLogin] = useState<Login | null>(null);
  const [loginId, setLoginId] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [showAdminDiv, setShowAdminDiv] = useState<boolean>(false);
  const [showSupportDiv, setShowSupportDiv] = useState<boolean>(false);
  const [showReportsDiv, setShowReportsDiv] = useState<boolean>(false);
  const [showDataDiv, setShowDataDiv] = useState<boolean>(false);
  const [showSuperAdminDiv, setShowSuperAdminDiv] = useState<boolean>(false);
  const [showAnalysisDiv, setShowAnalysisDiv] = useState<boolean>(false);
  const [showWritingFeedbackDiv, setShowWritingFeedbackDiv] = useState<boolean>(false);
  const [activeUsers, setActiveUsers] = useState<number>(0);
  const [connections, setConnections] = useState<number>(0);
  const [errorLog, setErrorLog] = useState<string>('');
  const [totalLoggedUsers, setTotalLoggedUsers] = useState<number>(0);
  const [isActiveOnly, setIsActiveOnly] = useState<boolean>(true);
  const [showLoginPanel, setShowLoginPanel] = useState<boolean>(false);
  const [showButtonsPanel, setShowButtonsPanel] = useState<boolean>(true);
  const [lessonBrowserVisible, setLessonBrowserVisible] = useState<boolean>(true);
  const [qnPerformanceVisible, setQnPerformanceVisible] = useState<boolean>(true);
  const [activeMenu, setActiveMenu] = useState<string | null>(null);
  const [dropdownResponse, setDropdownResponse] = useState<boolean>(false);
  const [showSalesReport, setShowSalesReport] = useState<boolean>(false);
  const [showSchoolUsage, setShowSchoolUsage] = useState<boolean>(false);
  const [showLoginUsage, setShowLoginUsage] = useState<boolean>(false);
  const [showAddDNC, setShowAddDNC] = useState<boolean>(false);
  const [showSearchDNC, setShowSearchDNC] = useState<boolean>(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const menusWithDropdown = ['Admin', 'Data', 'Support', 'Reports', 'SuperAdmin', 'Analysis'];
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

  const [alertInfo, setAlertInfo] = useState({ show: false, message: '', isSuccess: false });
  const [confirmInfo, setConfirmInfo] = useState<{
    show: boolean;
    message: string;
    onConfirm: () => void;
  }>({ show: false, message: '', onConfirm: () => { } });

  const superAdminUsers = ['shubhanga', 'shashanka', 'WILLIAM'];
  const developerUsers = ['shubhanga', 'shashanka', 'varun',]

  // const isSuperAdminUser = superAdminUsers.includes(
  //   (sessionStorage.getItem('L') || '').trim().toLowerCase()
  // );
  const isSuperAdminUser = superAdminUsers.some(
    user => user.toLowerCase() === (sessionStorage.getItem('L') || '').trim().toLowerCase()
  );
  const isDeveloperUser = developerUsers.some(
    user => user.toLowerCase() === (sessionStorage.getItem('L') || '').trim().toLowerCase()
  );
  console.log("£££", isSuperAdminUser);
  console.log("%%%", isDeveloperUser);

  const openBlockedWindow = (url: string, title: string, features: string) => {
    setIsBlocked(true);
    const newWindow = window.open(url, title, features);

    if (newWindow) {
      const timer = setInterval(() => {
        if (newWindow.closed) {
          clearInterval(timer);
          setIsBlocked(false);
        }
      }, 500);
    } else {
      setIsBlocked(false);
    }
  };

  const disabledOverlayStyle = {
    position: 'fixed' as const,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.2)',
    zIndex: 99999,
    cursor: 'wait'
  };


  const canShowMenuItem = (code?: string) => {
    if (!code) return true;

    const numCode = parseInt(code, 10);
    if (isNaN(numCode)) return true;

    if (isSuperAdminUser) return true;

    const menuRights = sessionStorage.getItem('MENU_RIGHTS') || '';
    const flag = menuRights.charAt(numCode - 1);

    return flag === 'Y';
  };

  // Codes 6, 7, 8 are special — they don't appear in the dropdown menu,
  // but control visibility of Edit / GO / View buttons in the login panel
  const canViewLogins = isSuperAdminUser || canShowMenuItem('6');
  const canEditLogins = isSuperAdminUser || canShowMenuItem('7');
  const canLoginAs = isSuperAdminUser || canShowMenuItem('8');



  const groupMenuItemsBySection = (menuItems: MenuItem[]) => {
    const sections: Record<string, MenuItem[]> = {};
    let currentSection = "Default";

    menuItems.forEach(item => {
      if (item.danger) {
        currentSection = item.label;
        if (!sections[currentSection]) {
          sections[currentSection] = [];
        }
      } else {
        if (!sections[currentSection]) {
          sections[currentSection] = [];
        }
        sections[currentSection].push(item);
      }
    });

    return sections;
  };
  const sectionHasVisibleItems = (sectionItems: MenuItem[]) => {
    return sectionItems.some(item => canShowMenuItem(item.code));
  };
  interface SupportNavigationParams {
    FilterType: string;
    S: string;
    F: string;
    L: string;
  }

  function getSupportNavigationUrl(filterType: string): string {
    const S = sessionStorage.getItem("S") || '';
    const F = sessionStorage.getItem("F") || '';
    const L = sessionStorage.getItem("L") || '';

    return `/SUPPORT/EL_ListOfTasks?FilterType=${encodeURIComponent(filterType)}&S=${encodeURIComponent(S)}&F=${encodeURIComponent(F)}&L=${encodeURIComponent(L)}`;
  }


  // Refs
  const preBtnSysAdminRef = useRef<HTMLButtonElement | null>(null);
  const objDivFloatRef = useRef<HTMLDivElement | null>(null);
  const objDivTimeIntervalRef = useRef<NodeJS.Timeout | null>(null);
  document.body.style.backgroundColor = '#214461'
  const [menus] = useState<MenuMap>({
    Admin: [
      { code: '1', label: 'Set Site Status' },
      { code: '2', label: 'Manage Site Message', navigation: '/WEBADMIN/ADMIN/EL_SetSiteMessage', status: 'C' },
      { code: '3', label: 'Clear Idle Seats' },
      { code: '4', label: 'Manage Program Updates', navigation: '/WEBADMIN/ADMIN/EL_ShowUpdates', status: 'C' },
      // { code: '5', label: 'Send eMail', navigation: '/WEBADMIN/MAILS/EL_SendMail', status: 'D' },
      { code: '5', label: 'Send eMail', status: 'D' },

      { label: 'School/eDealer', danger: true },
      { code: '9', label: 'Display List', navigation: '/WebAdmin/SCHOOLS/EL_ListSchools', status: 'C' },
      { code: '10', label: 'Add New', navigation: '/WebAdmin/SCHOOLS/EL_AddNewSchoolCode?CalledFrom=S', status: 'C' },

      { label: 'School', danger: true },
      { code: '11', label: 'Promote Students to Next year', navigation: '/SCHOOL/EL_PromoteSchoolStudentsToNextYear', status: 'C' },

      { label: 'eDealer', danger: true },
      { code: '12', label: 'Add Distributor', navigation: '/DEALER/EL_RegisterDistributors?ARD=A', status: 'C' },
      // { code: '12', label: 'Add Distributor', status: 'C' },
      { code: '13', label: 'Modify Distributor', navigation: '/DEALER/EL_RegisterDistributors?ARD=R', status: 'C' },
      // { code: '13', label: 'Modify Distributor', status: 'C' },
      { code: '14', label: 'Login Roles', navigation: '/WEBADMIN/ADMIN/EL_ManageRoles', status: 'C' },

      { label: 'Families', danger: true },
      { code: '15', label: 'Promote Students to Next year', navigation: '/SUPPORT/EL_Promote_Family_Student_Grade', status: 'C' }
    ],

    Data: [
      { label: 'DICS', danger: true },
      { code: '16', label: 'DIC Files', navigation: '/WebAdmin/DIC/EL_ManageDIC', status: 'C' },
      { code: '17', label: 'Keywords', navigation: '/WebAdmin/DIC/EL_ManageKeyWords', status: 'C' },

      { label: 'Product', danger: true },
      { code: '18', label: 'Products', navigation: '/WebAdmin/PRODUCT/EL_ManageProducts', status: 'C' },
      { code: '19', label: 'Packages', navigation: '/WebAdmin/PRODUCT/EL_ManagePackages', status: 'C' },
      { code: '20', label: 'Promotions', navigation: '/WebAdmin/PRODUCT/EL_ManagePromotions', status: 'C' },

      { label: 'Messages', danger: true },
      { code: '21', label: 'Weekly Tips', navigation: '/WebAdmin/LESSONPLAN/EL_ManageWeeklyTips', status: 'C' },
      { code: '22', label: 'WLP Messages', navigation: '/WEBADMIN/LESSONPLAN/EL_LessonPlanMessages', status: 'C' },

      { label: 'Rewards', danger: true },
      { code: '23', label: 'Avatars', navigation: '/WebAdmin/POINTS/EL_ManageAvatars', status: 'C' },
      { code: '24', label: 'Comps', navigation: '/WebAdmin/POINTS/EL_ManageComps', status: 'C' },
      { code: '25', label: 'Stores', navigation: '/WebAdmin/POINTS/EL_ManageStores', status: 'C' },

      { label: 'Maths Doctor', danger: true },
      { code: '31.1', label: 'RESET MathsDoctor', status: 'C' },
      { code: '26', label: 'Strand/Substrand/Qns', navigation: '/WebAdmin/MATHSDOCTOR/MD_ManageTopics', status: 'C' },
      { code: '27', label: 'Voucher Code', navigation: '/WebAdmin/MATHSDOCTOR/MD_ManageVoucherCodes', status: 'C' },
      { code: '28', label: 'Maths Doctor- Maths Wiz Link', navigation: '/WebAdmin/MATHSDOCTOR/EL_LinkMDandMW', status: 'C' },
      // { code: '29', label: 'View Questions', navigation: '/FirstTimeProcess/TestNewMSR' },
      { code: '29', label: 'View Questions', navigation: '/SYSADMIN/MathsDoctor/MathsDoctorQuestions', status: 'C' },
      // { code: '29', label: 'View Questions', status: 'D' },
      { code: '29.1', label: 'Test FTP' },
      { code: '30', label: 'View Exceptions', navigation: '/WebAdmin/MATHSDOCTOR/MD_ExceptionError', status: 'C' },
      { code: '31', label: 'Post Question Category', status: 'C' },




      { label: 'English Check', danger: true },
      { code: '87', label: 'RESET EnglishCheck', status: 'C' },
      { code: '88', label: 'English Strand/Substrand/Qns', navigation: '/WebAdmin/ENGLISHCHECK/EC_ManageTiopics', status: 'C' },
      { code: '89', label: 'English Check- English Wiz Link', navigation: '/WebAdmin/ENGLISHCHECK/EL_LinkECandEW', status: 'C' },
      { code: '90', label: 'English Questions', navigation: '/SYSADMIN/ENGLISHCHECK/EnglishCheckQuestions', status: 'C' },
      // { code: '90', label: 'English Questions', status: 'D' },
      { code: '91', label: 'English Post Question Category', status: 'C' },



      { label: 'Others', danger: true },
      { code: '32', label: 'View Lesson', navigation: '/SUPPORT/EL_ViewLesson', status: 'C' },
      // { code: '33', label: 'View Games', navigation: '/WebAdmin/GAMES/EL_ManageGames' },
      { code: '33', label: 'View Games' },
      { code: '34', label: 'Manage States', navigation: '/WebAdmin/Admin/EL_ManageStates', status: 'C' }
    ],


    Support: [
      { code: '35', label: 'Entry', navigation: getSupportNavigationUrl('Entry'), status: 'C' },
      { code: '36', label: 'View', navigation: getSupportNavigationUrl('View'), status: 'C' },
      { code: '37', label: 'Search Engine - AUS' },
      { code: '38', label: 'Courtesy Call List', status: 'C' },
      { code: '39', label: 'Customer Support Entry Details', navigation: '/SUPPORT/EL_CustomerSupportEntryDetails', status: 'C' },
      { code: '40', label: 'Flags And Alerts', navigation: '/SUPPORT/EL_FlagedAlertList', status: 'C' },

      { label: 'WLP', danger: true },
      { code: '41', label: 'Create MathsDoctor LessonPlan', status: 'C' },
      { code: '42', label: 'Create Default LessonPlan - Maths', status: 'C' },
      { code: '92', label: 'Create EnglishCheck LessonPlan', status: 'C' },
      { code: '43', label: 'Create Default LessonPlan - English', status: 'C' },
      { code: '44', label: 'View LessonPlan - Maths', status: 'C' },
      { code: '45', label: 'View LessonPlan - English', status: 'C' },
      { code: '46', label: 'Default WLP running out - Maths', status: 'C' },
      { code: '47', label: 'Default WLP running out - English', status: 'C' },
      { code: '48', label: 'MathsDoctor WLP running out', navigation: '/SUPPORT/EL_ListWLPsRunningout', status: 'C' },
      { code: '68', label: 'Remove lessons from WLP', navigation: '/SUPPORT/EL_RemoveLessonsFromWLP', status: 'C' },
      { code: '69', label: 'MD started & Not completed', navigation: '/SUPPORT/EL_ListofUsersMDNotCompleted', status: 'C' },
      { code: '70', label: 'Families Registered By APP', navigation: '/WEBADMIN/REPORTS/EL_FamilyRegisteredFromAPP', status: 'C' },

      { label: 'DNC', danger: true },
      { code: '49', label: 'Add DNC', status: 'C' },
      { code: '50', label: 'Search DNC', status: 'C' },

      { label: 'Others', danger: true },
      { code: '51', label: 'View Points', navigation: '/SUPPORT/EL_ViewPoints', status: 'C' },
      { code: '52', label: 'Show eMails sent to Family', },
      // { code: '53', label: 'Write Reports', navigation: '/SUPPORT/TeacherReport/EL_ListFamilies'},
      { code: '53', label: 'Write Reports' }
    ],

    Reports: [
      { code: '54', label: 'Structured Reports', navigation: '/WebAdmin/Reports/EL_GeneralQuery', status: 'C' },
      { code: '55', label: 'Active Users Chart' },
      { code: '56', label: 'Tutor Center Usage', navigation: '/WebAdmin/Reports/EL_TutorCenterUsage', status: 'C' },
      { code: '57', label: 'School Usage', navigation: '/WebAdmin/Reports/EL_SchoolUsage', status: 'C' },
      { code: '58', label: 'Family Usage Analysis', navigation: '/WebAdmin/Reports/EL_FamilyUsageAnalysis', status: 'C' },
      { code: '59', label: 'Sales Report', status: 'C' },
      { code: '60', label: 'Login Usage', status: 'C', },
      { code: '100', label: 'Progress MD Report', navigation: '/SYSADMIN/Reports/ProgressMDReport', status: 'C', },
      { code: '97', label: 'MDOverall Analysis Report', navigation: '/SUPPORT/EL_MDOverallAnalysis', status: 'C', },

      { label: 'Tutors Report', danger: true },
      { code: '76', label: 'Add/Remove Tutors', navigation: '/SYSADMIN/Reports/AddTutor', status: 'C' },
      { code: '71', label: 'Tutor Entries Report', navigation: '/SYSADMIN/Reports/TutorSupportReport', status: 'C' },
      { code: '73', label: 'Call And Support', navigation: '/SYSADMIN/Reports/CallAndSupport', status: 'C' },
      { code: '74', label: 'CPC Installers Report', navigation: '/SYSADMIN/Reports/CPCInstallersReport', status: 'C' },
      { code: '78', label: 'CS-No Open Tasks', navigation: '/SYSADMIN/Reports/NoOpenTasks', status: 'C' },

      { label: 'YLA Report', danger: true },
      { code: '86', label: 'Live Lessons Report', navigation: '/SYSADMIN/Reports/YLALessonsReport', status: 'C' },

      { label: 'Students Work', danger: true },
      { code: '61', label: 'User Diary', status: 'C' },
      { code: '61', label: 'Extension Student', navigation: '/SYSADMIN/Reports/ExtensionStudent', status: 'C' },
      { code: '62', label: 'PT Report', navigation: '/SYSADMIN/Reports/PTReport', status: 'C' },

      { label: 'Students MD', danger: true },
      // { code: '163', label: 'Brick Report' },
      // { code: '164', label: 'Knowledge Gap Report', navigation: '/MD_Reports/MD_EReport_PDF' },
      { code: '164', label: 'Knowledge Gap Report' },
      // { code: '65', label: 'Navigation Report', navigation: '/MD_Reports/MD_NavigationReport' },
      { code: '65', label: 'Navigation Report', status: 'C' },
      // { code: '66', label: 'Current WLP Report', navigation: '/MD_Reports/MD_WPReport_PDF' },
      { code: '66', label: 'Current WLP Report' },
      // { code: '67', label: 'Performance Report', navigation: '/MD_Reports/MD_WeeklyPerformanceReport' },
      { code: '67', label: 'Performance Report' },
      { code: '68', label: 'New MD PDF Report', status: 'C' },
      // { code: '69', label: 'Still Report', navigation: '/MathsDoctor/Reports/StillReport' },
      { code: '69', label: 'Still Report', status: 'C' },
      // { code: '70', label: 'Moving Report', navigation: '/MathsDoctor/Reports/MovingReport' },
      { code: '70', label: 'Moving Report' },
      { label: 'Students EC', danger: true },
      { code: '93', label: 'EC Navigation Report', status: 'C' },
      { code: '94', label: 'New EC PDF Report', status: 'C' },
    ],

    SuperAdmin: [
      { code: '501', label: 'SysAdmin Users List', navigation: '/WebAdmin/ADMIN/EL_ListUsers', status: 'C' },
      { code: '502', label: 'Link to Payment Website' },
      { code: '503', label: 'Manage Database Tables', navigation: '/WebAdmin/ADMIN/EL_GeneralARD', status: 'C' },
      { code: '504', label: 'Manage Settings', navigation: '/WEBADMIN/ADMIN/EL_ManageSettings', status: 'C' },
      { code: '505', label: 'Show Error LOG', navigation: '/WebAdmin/Reports/EL_ShowErrorLog', status: 'C' },
      { code: '98', label: 'SysAdmin Tutor List', navigation: '/WebAdmin/ADMIN/EL_ListTAUsers', status: 'C' }
    ],
    Analysis: [
      { code: "81", label: 'Lesson Browser', navigation: "/LessonBrowser/LessonBrowser", status: 'C' },
      { code: "82", label: 'Question Performance', navigation: "/SUPPORT/EL_Questionperformance", status: 'C' },
      { code: "83", label: 'Lesson Performance', navigation: "/SUPPORT/EL_Lessonperformance", status: 'C' },
      { code: "84", label: 'Test Performance', navigation: "/SUPPORT/EL_Testperformance", status: 'C' },
      { code: "85", label: 'Test Summary', navigation: "/SUPPORT/EL_TestSummary", status: 'C' },
      { label: 'AI', danger: true },
      { code: "99", label: 'Writing Feedback', navigation: "/SUPPORT/Writing_Feedback", status: 'C' }
    ],

  });

  // Hide the bottom panel (Country, SchoolCode, Family dropdowns etc.) if the user
  // has no permitted items in Admin / Data / Reports / SuperAdmin / Analysis menus.
  // This matches VB behaviour — Support-only users see just the Support button, no panel.
  const hasNonSupportMenu =
    isSuperAdminUser ||
    (['Admin', 'Data', 'Reports', 'SuperAdmin', 'Analysis'] as const).some(menu =>
      (menus[menu] || []).some(item => item.code && canShowMenuItem(item.code))
    );

  const formatReportDate = (dateString: string): string => {
    if (!dateString) return '';

    const [year, month, day] = dateString.split('-');

    if (!year || !month || !day) {
      return dateString;
    }

    return `${day}/${month}/${year}`;
  };

  const schoolCategories = [
    { value: 'SCH', label: 'School' },
    { value: 'LIB', label: 'Library' },
    { value: 'ISP', label: 'ISP' },
    { value: 'DLR', label: 'eDealer' },
  ];


  const getUserCategory = () => {
    if (selectedLogin) {
      if (admins.some(admin => admin.login === selectedLogin.login)) {
        return 'Admin';
      } else if (families.some(family => family.login === selectedLogin.login)) {
        return 'Family user';
      } else if (teachers.some(teacher => teacher.login === selectedLogin.login)) {
        return 'Teacher';
      } else if (students.some(student => student.login === selectedLogin.login)) {
        return schoolType === 'SCH' ? 'Student' : 'User';
      }
    }
    // return 'User';
  };


  // API Calls
  const fetch_activeusercount = async () => {
    setDropdownResponse(true);
    try {
      const res = await fetch(`${API_BASE_URL}api/get_activeusercount/`);
      const data = await res.json();
      setActiveUsers(data?.activeusersall ?? 0);
      setConnections(data?.activeconnections ?? 0);
      setErrorLog(data?.errorlogcount ?? 0);
      setTotalLoggedUsers(data?.usedbycount ?? 0);
    } catch (err) {
      console.error('API error:', err);
    }
    setDropdownResponse(false);
  };

  const fetchCountries = async () => {
    setDropdownResponse(true);
    try {
      const res = await fetch(`${API_BASE_URL}api/get_countries/`);
      const data = await res.json();

      const apiCountries = data.countries;

      if (apiCountries.length > 0) {
        setCountries(apiCountries);
        setSelectedCountry(apiCountries[0]);
      }
    } catch (err) {
      console.error('Country API failed:', err);
    }
    setDropdownResponse(false);
  };



const formatValidityDate = (dateString: string): string => {
  if (!dateString) return '';

  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return dateString;
  }

  const day = date.getDate();

  const month = date.toLocaleString('en-GB', {
    month: 'short',
  });

  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};

  // Handlers
  const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedCountry(e.target.value);
  };

  const handleSchoolTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newSchoolType = e.target.value;
    setSchoolType(newSchoolType);
    setSelectedSchool(null);
    setAdmins([]);
    setFamilies([]);
    setTeachers([]);
    setStudents([]);
    setChildren([]);
    setSelectedLogin(null);
    setSelectedFamily('');
    setSelectedChild('');
    setLoginId('');
    setPassword('');
    setMdReports([]);
    setEcReports([]);
    setSelectedMDReport('');
    setSelectedECReport('');
    setSelectedReport('');

    // if (selectedCountry) {
    //   fetchSchoolCodes(selectedCountry, newSchoolType);
    // }
  };


  const fetchSchoolCodes = async (country: string, category: string = schoolType) => {
    setDropdownResponse(true);
    try {
      const res = await fetch(`${API_BASE_URL}api/get_schooldcodes/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ country, category }),
      });
      const data = await res.json();
      setApiSchools(data || []);

      if (data && data.length > 0) {
        loadSchoolData(data[0].schoolcode, data);
      } else {
        setSelectedSchool(null);
      }

    } catch (err) {
      console.error('School API error:', err);
      setApiSchools([]);
    }
    setDropdownResponse(false);
  };


  const loadSchoolData = async (schoolcode: string, sourceList: SchoolAPI[] = apiSchools) => {
    if (!schoolcode) return;

    const school = sourceList.find(s => s.schoolcode === schoolcode);
    if (!school) return;

    setDropdownResponse(true);
    try {
      const post = (url: string, body: any) =>
        fetch(`${API_BASE_URL}${url}/`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        }).then(r => r.json());

      const [adminsRes, familiesRes, teachersRes, studentsRes] = await Promise.all([
        post('api/get_admins', { schoolcode }),
        post('api/get_families', { schoolcode, isActiveOnly }),
        post('api/get_teachers', { schoolcode }),
        post('api/get_students', { schoolcode, category: schoolType }),
      ]);

      setAdmins(adminsRes);
      setFamilies(familiesRes);

      console.log('Family', families)
      sessionStorage.setItem('SelectedSchoolCode', schoolcode)
      setTeachers(teachersRes);
      setStudents(studentsRes);
      setChildren([]);
      setMdReports([]);
      setEcReports([]);
      setSelectedMDReport('');
      setSelectedECReport('');
      setSelectedReport('');

      setSelectedSchool({
        code: school.schoolcode,
        name: school.name,
        status: school.status,
        maxUsers: school.maxusers != null ? school.maxusers.toString() : '0',
        maxSeats: school.maxseats != null ? school.maxseats.toString() : '0',
        admins: adminsRes.length.toString(),
        regFamilies: familiesRes.length.toString(),
        regTeachers: teachersRes.length.toString(),
        regUsers: studentsRes.length.toString(),
        eligibleForIncentives: 'Y',
        dlrOrHO: school.country === 'Australia' ? '' : '',
        category: school.category,
      });

    } catch (err) {
      console.error('Error fetching school data:', err);
    }
    setDropdownResponse(false);
  };

  const handleSchoolSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    loadSchoolData(e.target.value);
  };

  const handleAdminSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const login = e.target.value;
    const admin = admins.find(a => a.login === login) || null;
    setSelectedLogin(admin);
    setLoginId(login);
    setPassword(admin ? admin.password : '');
    sessionStorage.setItem("Login", login);
  };

  const handleFamilySelect = async (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setDropdownResponse(true);

    const login = e.target.value;

    // No family selected
    if (!login || login === '--Select--') {
      setSelectedFamily('');
      setSelectedLogin(null);
      setSelectedChild('');
      setSelectedChildLogin(null);
      setChildren([]);
      setLoginId('');
      setPassword('');
      return;
    }

    setSelectedFamily(login);

    const family = families.find(
      f => f.login === login
    ) || null;

    // ---------------------------------------------------------
    // IMPORTANT:
    // selectedLogin MUST remain the FAMILY.
    // VB does this in fn_SelectLogin(2).
    // ---------------------------------------------------------
    setSelectedLogin(family);

    setLoginId(login);
    setPassword(family?.password || '');

    // Clear previously selected child
    setSelectedChild('');
    setSelectedChildLogin(null);

    // Clear reports
    setSelectedReport('');
    setSelectedMDReport('');
    setSelectedECReport('');

    try {
      const res = await fetch(
        `${API_BASE_URL}api/get_children/`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            schoolcode: selectedSchool?.code,
            familycode: login,
          }),
        }
      );

      const data = await res.json();

      if (!res.ok) {
        console.error('get_children failed:', data);
        setChildren([]);
        return;
      }

      setChildren(Array.isArray(data) ? data : []);

      // Store family LName as surname
      if (
        Array.isArray(data) &&
        data.length > 0 &&
        data[0].familyLName
      ) {
        sessionStorage.setItem(
          'surname',
          data[0].familyLName
        );
      } else {
        sessionStorage.removeItem('surname');
      }

    } catch (err) {
      console.error(
        'Error fetching children:',
        err
      );

      setChildren([]);
    } finally {
      setDropdownResponse(false);
    }
  };
  const handleTeacherSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const login = e.target.value;
    const teacher = teachers.find(t => t.login === login) || null;
    setSelectedLogin(teacher);
    setLoginId(login);
    setPassword(teacher ? teacher.password : '');
  };

  const handleStudentSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const login = e.target.value;
    const student = students.find(s => s.login === login) || null;
    setSelectedLogin(student);
    setLoginId(login);
    setPassword(student ? student.password : '');
  };

  const handleChildSelect = async (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const login = e.target.value;

    // ---------------------------------------------------------
    // No child selected
    // ---------------------------------------------------------
    if (!login || login === '--Select--') {
      setSelectedChild('');
      setSelectedChildLogin(null);

      setSelectedReport('');
      setSelectedMDReport('');
      setSelectedECReport('');

      return;
    }

    const child =
      children.find(c => c.login === login) || null;

    if (!child) {
      setSelectedChild('');
      setSelectedChildLogin(null);
      return;
    }

    // ---------------------------------------------------------
    // Keep the CHILD separately.
    //
    // DO NOT call setSelectedLogin().
    //
    // selectedLogin must continue to contain the FAMILY.
    // ---------------------------------------------------------
    setSelectedChild(login);

    setSelectedReport('');
    setSelectedMDReport('');
    setSelectedECReport('');

    try {
      const schoolcode = selectedSchool?.code || '';
      const familycode =
        selectedFamily ||
        sessionStorage.getItem('SelectedFamilyCode') ||
        sessionStorage.getItem('S') ||
        '';

      if (!schoolcode || !familycode) {
        console.error(
          'Missing schoolcode/familycode for child points',
          {
            schoolcode,
            familycode,
            login,
          }
        );

        // Still show std if available
        setSelectedChildLogin({
          ...child,
          points: child.points ?? 0,
        });

        return;
      }

      // -------------------------------------------------------
      // Fetch child Points separately.
      // This matches our dedicated API.
      // -------------------------------------------------------
      const response = await fetch(
        `${API_BASE_URL}api/get_child_points/`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            schoolcode,
            familycode,
            login,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        console.error(
          'get_child_points failed:',
          data
        );

        // Preserve child std even if points API fails
        setSelectedChildLogin({
          ...child,
          points: child.points ?? 0,
        });

        return;
      }

      const points = data?.points ?? 0;

      // -------------------------------------------------------
      // Store child information separately.
      // -------------------------------------------------------
      setSelectedChildLogin({
        ...child,
        points,
      });

      console.log(
        'Selected child:',
        login
      );

      console.log(
        'Child GradeYear:',
        child.std
      );

      console.log(
        'Child Points:',
        points
      );

    } catch (error) {
      console.error(
        'Error fetching child points:',
        error
      );

      setSelectedChildLogin({
        ...child,
        points: child.points ?? 0,
      });
    }
  };

  // const handleMdReportSelect = (
  //   e: React.ChangeEvent<HTMLSelectElement>
  // ) => {
  //   const reportNo = e.target.value;

  //   setSelectedMDReport(reportNo);
  //   setSelectedReport(reportNo);

  //   sessionStorage.setItem('ReportNo', reportNo);

  //   console.log('Selected MD Report:', reportNo);
  // };

  // const handleECReportSelect = (
  //   e: React.ChangeEvent<HTMLSelectElement>
  // ) => {
  //   const reportNo = e.target.value;

  //   setSelectedECReport(reportNo);
  //   setSelectedReport(reportNo);

  //   sessionStorage.setItem('ReportNo', reportNo);

  //   console.log('Selected EC Report:', reportNo);
  // };

  // LETTING USER CHOOSE EITHER MD OR EC REPORT, BUT NOT BOTH. IF USER SELECTS MD REPORT, EC REPORT IS CLEARED AND VICE VERSA. 07/09/2026

  // const handleMdReportSelect = (
  //   e: React.ChangeEvent<HTMLSelectElement>
  // ) => {
  //   const reportNo = e.target.value;

  //   // Clear EC report when MD report is selected
  //   setSelectedECReport('');

  //   setSelectedMDReport(reportNo);
  //   setSelectedReport(reportNo);

  //   sessionStorage.setItem('ReportNo', reportNo);

  //   console.log('Selected MD Report:', reportNo);
  // };

  // const handleECReportSelect = (
  //   e: React.ChangeEvent<HTMLSelectElement>
  // ) => {
  //   const reportNo = e.target.value;

  //   // Clear MD report when EC report is selected
  //   setSelectedMDReport('');

  //   setSelectedECReport(reportNo);
  //   setSelectedReport(reportNo);

  //   sessionStorage.setItem('ReportNo', reportNo);

  //   console.log('Selected EC Report:', reportNo);
  // };


  const handleMdReportSelect = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const reportNo = e.target.value;

    // Clear EC report when MD report is selected
    setSelectedECReport('');

    setSelectedMDReport(reportNo);
    setSelectedReport(reportNo);

    sessionStorage.setItem('ReportNo', reportNo);

    console.log('Selected MD Report:', reportNo);
  };

  const handleECReportSelect = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const reportNo = e.target.value;

    // Clear MD report when EC report is selected
    setSelectedMDReport('');

    setSelectedECReport(reportNo);
    setSelectedReport(reportNo);

    sessionStorage.setItem('ReportNo', reportNo);

    console.log('Selected EC Report:', reportNo);
  };


  const handleLoginAs = () => {
    if (!loginId) {
      setAlertInfo({ show: true, message: "Please select a login", isSuccess: false });
      return;
    }
    if (selectedLogin?.status !== 'A') {
      setAlertInfo({ show: true, message: "User account is Inactive.", isSuccess: false });
      return;
    }
    if (selectedLogin?.validity.includes('**')) {
      setAlertInfo({ show: true, message: "User account has expired.", isSuccess: false });
      return;
    }
    setAlertInfo({ show: true, message: `Logging in as ${loginId}`, isSuccess: false });
  };

  const handleEditLogin = () => {
    if (!selectedSchool?.code || !selectedFamily) {
      setAlertInfo({ show: true, message: "Please select a School, Family, and Login first", isSuccess: false });
      return;
    }

    const url = `/SYSADMIN/EditLogin?SchoolCode=${encodeURIComponent(selectedSchool.code)}&FamilyCode=${encodeURIComponent('A')}&Login=${encodeURIComponent(selectedFamily)}`;

    window.open(url, '_blank');
  };

  // const handleGoLogin = () => {
  //   if (!loginId && !selectedFamily) {
  //     console.log('LoginId', loginId, 'Family', selectedFamily)
  //     setAlertInfo({ show: true, message: "Please select a login", isSuccess: false });
  //     return;
  //   }
  //   navigate('/SUPPORT/SupportDashboard', { state: { login: loginId } });
  // };

  const handleGoLogin = () => {
    const adminSelected = loginId !== '';

    if (!adminSelected) {
      setAlertInfo({
        show: true,
        message: "Please select Admin / Staff",
        isSuccess: false
      });
      return;
    }
    sessionStorage.setItem('school_code', sessionStorage.getItem('SelectedSchoolCode') || '')
    sessionStorage.setItem('family_code', sessionStorage.getItem('S') || '');

    navigate('/SUPPORT/SupportDashboard', {
      state: { login: loginId }
    });
  };

  const handleShowWindowSize = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;

    alert(`${width} / ${height}`);
  };

  const handleVMLogs = () => {
    navigate('/Matrix')
  };


  const handleDivOver = (div: HTMLDivElement) => {
    if (objDivTimeIntervalRef.current) clearTimeout(objDivTimeIntervalRef.current);
    objDivFloatRef.current = div;
  };

  const handleDivOut = (div: HTMLDivElement) => {
    objDivTimeIntervalRef.current = setTimeout(() => {
      if (objDivFloatRef.current === div) {
        div.style.display = 'none';
      }
    }, 400);
  };

  const handleConfirmAndSetSiteMode = () => {
    const newMode = siteMode === 'LIVE' ? 'Maintenance' : 'LIVE';
    setConfirmInfo({
      show: true,
      message: `Do you want to set website to ${newMode} mode?`,
      onConfirm: () => setSiteMode(newMode)
    })

  };

  const handleActiveChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsActiveOnly(e.target.checked);
  };

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    if (!loginId || !password) {
      setAlertInfo({ show: true, message: "Please enter your Login / Password", isSuccess: false });
      return;
    }
    setAlertInfo({ show: true, message: "Login successful", isSuccess: false });
  };

  const handleCancel = () => {
    window.close();
  };

  const handleForgotPassword = (e: React.MouseEvent) => {
    e.preventDefault();
    setAlertInfo({ show: true, message: "Forgot password clicked", isSuccess: false });
  };

  const handleNavigation = (item: MenuItem) => {
    if (item.danger) return;

    const mdReportItems = [
      'Knowledge Gap Report',
      'Navigation Report',
      'Current WLP Report',
      'Performance Report',
      'New MD PDF Report',
      'Still Report',
      'Moving Report'
    ];

    const ecReportItems = [
      'EC Navigation Report',
      'New EC PDF Report'
    ];

    // User selected EC report, so only Students EC reports are allowed
    if (mdReportItems.includes(item.label) && selectedECReport) {
      setAlertInfo({
        show: true,
        message:
          'You have selected EC Reports.<br />Please choose a report from Students EC.',
        isSuccess: false
      });
      return;
    }

    // User selected MD report, so only Students MD reports are allowed
    if (ecReportItems.includes(item.label) && selectedMDReport) {
      setAlertInfo({
        show: true,
        message:
          'You have selected MD Reports.<br />Please choose a report from Students MD.',
        isSuccess: false
      });
      return;
    }

    if (item.label === 'Sales Report') {
      setShowSalesReport(true);
      return;
    }

    if (item.label === 'School Usage') {
      setShowSchoolUsage(true);
      return;
    }

    if (item.label === 'Writing Feedback') {
      const writingWindow = window.open(
        item.navigation || '/SUPPORT/Writing_Feedback',
        'WritingFeedbackWindow',
        `width=${window.screen.availWidth},height=${window.screen.availHeight},left=0,top=0,resizable=yes,scrollbars=yes`
      );

      if (writingWindow) {
        writingWindow.moveTo(0, 0);
        writingWindow.resizeTo(
          window.screen.availWidth,
          window.screen.availHeight
        );
        writingWindow.focus();
      }

      return;
    }
    if (item.label === 'Login Usage') {
      if (!selectedSchool || !selectedSchool.code) {
        setAlertInfo({
          show: true,
          message: "Please select School Code",
          isSuccess: false
        });
        return;
      }

      const url =
        `/WEBADMIN/REPORTS/EL_LoginUsage` +
        `?SchoolCode=${encodeURIComponent(selectedSchool.code)}` +
        `&FamilyCode=${encodeURIComponent(selectedFamily)}` +
        `&Login=${encodeURIComponent(selectedChild)}` +
        `&From=${encodeURIComponent('Sysadmin')}`;


      window.open(url, "_blank");
      return;
    }
    if (item.label === 'Post Question Category') {
      if (!selectedSchool || !selectedSchool.code) {
        // setAlertInfo({ show: true, message: "Please select School Code", isSuccess: false });
        return;
      }
      const width = 1100;
      const height = 700;
      const left = (window.screen.availWidth - width) / 2;
      const top = (window.screen.availHeight - height) / 2;

      const url = `/WebAdmin/MATHSDOCTOR/MD_ValidateQnTypes?schoolCode=${encodeURIComponent(selectedSchool.code)}&familyCode=${encodeURIComponent(selectedFamily)}&login=${encodeURIComponent(selectedChild)}`;

      openBlockedWindow(
        url,
        'PostQuestionCategory',
        `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`
      );
      // navigate(`WebAdmin/MATHSDOCTOR/MD_ValidateQnTypes?schoolCode=${encodeURIComponent(selectedSchool.code)}&familyCode=${encodeURIComponent(selectedFamily)}&login=${encodeURIComponent(selectedChild)}`);
      // setShowLoginUsage(true);
      return;
    }

    if (item.label === 'Promotions') {
      if (!selectedSchool || !selectedSchool.code) {
        setAlertInfo({ show: true, message: "Please select a school code", isSuccess: false });
        return;
      }
      navigate(`/WebAdmin/PRODUCT/EL_ManagePromotions?SchoolCode=${encodeURIComponent(selectedSchool.code)}`);
      return;
    }

    if (item.label === 'English Post Question Category') {
      alert("'This operation will post the Question Category from XML to Database.\n\nThis operation will take a few minutes\n\nDo you want to proceed?'")
      // navigate('WebAdmin/ENGLISHCHECK/EC_ValidateQnTypes.aspx', 'Validate EC question types', 'W=800,H=500,Movable=Y');
      navigate('/WebAdmin/ENGLISHCHECK/EC_ValidateQnTypes');
      return;
    }


    // if (item.label === "View Points" || item.label === "RESET Maths Doctor") {
    if (item.label === "View Points") {
      if (!selectedSchool || !selectedSchool.code || !selectedChild || !selectedChildLogin) {
        setAlertInfo({ show: true, message: "Please Select required user", isSuccess: false });
        return;
      }
      navigate(`/SUPPORT/EL_ViewPoints?SchoolCode=${encodeURIComponent(selectedSchool.code)}&FamilyCode=${encodeURIComponent(selectedFamily)}&Login=${encodeURIComponent(selectedChild)}`);
      return;
    }
    if (item.label === "RESET MathsDoctor") {
      if (!selectedSchool || !selectedSchool.code || !selectedChild || !selectedChildLogin) {
        setAlertInfo({ show: true, message: "Please Select required user", isSuccess: false });
        return;
      }
      const url = `/SYSADMIN/MathsDoctor/ResetMD?SchoolCode=${encodeURIComponent(selectedSchool.code)}&FamilyCode=${encodeURIComponent(selectedFamily)}&Login=${encodeURIComponent(selectedChild)}`;

      const width = 1800;
      const height = 1200;
      const left = (window.screen.availWidth - width) / 2;
      const top = (window.screen.availHeight - height) / 2;

      openBlockedWindow(
        url,
        'RESET MathsDoctor',
        `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`
      );
      return;
    }
    if (item.label === "Create MathsDoctor LessonPlan") {
      if (!selectedSchool || !selectedSchool.code || !selectedChild || !selectedChildLogin) {
        setAlertInfo({ show: true, message: "Please Select required user", isSuccess: false });
        return;
      }

      let countryName = 'Australia';
      if (selectedSchool.code) {
        const parts = selectedSchool.code.split('_');
        const suffix = parts[parts.length - 1].toUpperCase();
        if (suffix === 'AU') countryName = 'Australia';
        else if (suffix === 'UK') countryName = 'United Kingdom';
        else if (suffix === 'US') countryName = 'USA';
        else if (suffix === 'CA') countryName = 'Canada';
        else if (suffix === 'NZ') countryName = 'New Zealand';
        else if (suffix === 'IN') countryName = 'India';
        else if (suffix === 'ZA') countryName = 'South Africa';
      }

      const url = `SYSADMIN/MathsDoctor/CreateMathsDoctorLessonPlan?C=${encodeURIComponent(selectedSchool.code)}&F=${encodeURIComponent(selectedFamily)}&L=${encodeURIComponent(selectedChild)}&GrdYr=${selectedLogin?.std}&Subject=${'Mathematics'}&KT=${encodeURIComponent(countryName)}`;

      const width = window.innerWidth;
      const height = window.innerHeight;
      const left = (window.screen.width / 2) - (width / 2);
      const top = (window.screen.height / 2) - (height / 2);

      openBlockedWindow(url, 'CreateDefaultLP', `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`); return;
    }


    if (item.label === "Create EnglishCheck LessonPlan") {
      if (!selectedSchool || !selectedSchool.code || !selectedChild || !selectedChildLogin) {
        setAlertInfo({ show: true, message: "Please Select required user", isSuccess: false });
        return;
      }

      let countryName = 'Australia';
      if (selectedSchool.code) {
        const parts = selectedSchool.code.split('_');
        const suffix = parts[parts.length - 1].toUpperCase();
        if (suffix === 'AU') countryName = 'Australia';
        else if (suffix === 'UK') countryName = 'United Kingdom';
        else if (suffix === 'US') countryName = 'USA';
        else if (suffix === 'CA') countryName = 'Canada';
        else if (suffix === 'NZ') countryName = 'New Zealand';
        else if (suffix === 'IN') countryName = 'India';
        else if (suffix === 'ZA') countryName = 'South Africa';
      }

      const url = `SYSADMIN/EnglishCheck/CreateEnglishCheckLessonPlan?C=${encodeURIComponent(selectedSchool.code)}&F=${encodeURIComponent(selectedFamily)}&L=${encodeURIComponent(selectedChild)}&GrdYr=${selectedLogin?.std}&Subject=${'English'}&KT=${encodeURIComponent(countryName)}`;

      const width = window.innerWidth;
      const height = window.innerHeight;
      const left = (window.screen.width / 2) - (width / 2);
      const top = (window.screen.height / 2) - (height / 2);

      openBlockedWindow(url, 'CreateDefaultLP', `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`); return;
    }

    if (item.label === "Create Default LessonPlan - Maths") {
      if (!selectedSchool || !selectedSchool.code || !selectedChild || !selectedChildLogin) {
        setAlertInfo({ show: true, message: "Please Select required user", isSuccess: false });
        return;
      }

      let countryName = 'Australia';
      if (selectedSchool.code) {
        const parts = selectedSchool.code.split('_');
        const suffix = parts[parts.length - 1].toUpperCase();
        if (suffix === 'AU') countryName = 'Australia';
        else if (suffix === 'UK') countryName = 'United Kingdom';
        else if (suffix === 'US') countryName = 'USA';
        else if (suffix === 'CA') countryName = 'Canada';
        else if (suffix === 'NZ') countryName = 'New Zealand';
        else if (suffix === 'IN') countryName = 'India';
        else if (suffix === 'ZA') countryName = 'South Africa';
      }

      const url = `Support/EL_CreateDefaultLessonPlan?C=${encodeURIComponent(selectedSchool.code)}&F=${encodeURIComponent(selectedFamily)}&L=${encodeURIComponent(selectedChild)}&GrdYr=${selectedLogin?.std}&Subject=${'Mathematics'}&KT=${encodeURIComponent(countryName)}`;

      const width = window.innerWidth;
      const height = window.innerHeight;
      const left = (window.screen.width / 2) - (width / 2);
      const top = (window.screen.height / 2) - (height / 2);

      openBlockedWindow(url, 'CreateDefaultLP', `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`);
      return;
    }

    if (item.label === "RESET EnglishCheck") {
      if (!selectedSchool?.code || !selectedFamily || !selectedChild) {
        setAlertInfo({
          show: true,
          message: "Please Select required user",
          isSuccess: false,
        });
        return;
      }

      navigate(
        `/SYSADMIN/EnglishCheck/ResetEC?SchoolCode=${encodeURIComponent(selectedSchool.code)}&FamilyCode=${encodeURIComponent(selectedFamily)}&Login=${encodeURIComponent(selectedChild)}`
      );
      return;
    }

    if (item.label === "Create Default LessonPlan - English") {
      if (!selectedSchool || !selectedSchool.code || !selectedChild || !selectedChildLogin) {
        setAlertInfo({ show: true, message: "Please Select required user", isSuccess: false });
        return;
      }

      let countryName = 'Australia';
      if (selectedSchool.code) {
        const parts = selectedSchool.code.split('_');
        const suffix = parts[parts.length - 1].toUpperCase();
        if (suffix === 'AU') countryName = 'Australia';
        else if (suffix === 'UK') countryName = 'United Kingdom';
        else if (suffix === 'US') countryName = 'USA';
        else if (suffix === 'CA') countryName = 'Canada';
        else if (suffix === 'NZ') countryName = 'New Zealand';
        else if (suffix === 'IN') countryName = 'India';
        else if (suffix === 'ZA') countryName = 'South Africa';
      }

      const url = `Support/EL_CreateDefaultLessonPlan?C=${encodeURIComponent(selectedSchool.code)}&F=${encodeURIComponent(selectedFamily)}&L=${encodeURIComponent(selectedChild)}&GrdYr=${selectedLogin?.std}&Subject=${'English'}&KT=${encodeURIComponent(countryName)}`;

      const width = window.innerWidth;
      const height = window.innerHeight;
      const left = (window.screen.width / 2) - (width / 2);
      const top = (window.screen.height / 2) - (height / 2);

      openBlockedWindow(url, 'CreateDefaultLP', `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`);
      return;
    }
    if (item.label === "View LessonPlan - Maths") {
      if (!selectedSchool || !selectedSchool.code || !selectedChild || !selectedChildLogin) {
        setAlertInfo({
          show: true,
          message: "Please Select required user",
          isSuccess: false
        });
        return;
      }

      window.open(
        `/SUPPORT/EL_ViewLessonPlan?SchoolCode=${encodeURIComponent(selectedSchool.code)}&FamilyCode=${encodeURIComponent(selectedFamily)}&Login=${encodeURIComponent(selectedChild)}&Subject=Mathematics`,
        "_blank"
      );

      return;
    }
    if (item.label === "View LessonPlan - English") {
      if (!selectedSchool || !selectedSchool.code || !selectedChild || !selectedChildLogin) {
        setAlertInfo({
          show: true,
          message: "Please Select required user",
          isSuccess: false
        });
        return;
      }

      window.open(
        `/SUPPORT/EL_ViewLessonPlan?SchoolCode=${encodeURIComponent(selectedSchool.code)}&FamilyCode=${encodeURIComponent(selectedFamily)}&Login=${encodeURIComponent(selectedChild)}&Subject=English`,
        "_blank"
      );

      return;
    }


    if (item.label === "Default WLP running out - Maths") {
      // if (!selectedSchool || !selectedSchool.code || !selectedChild || !selectedChildLogin) {
      //   setAlertInfo({ show: true, message: "Please Select required user", isSuccess: false });
      //   return;
      // }
      if (!selectedSchool || !selectedSchool.code) {
        setAlertInfo({ show: true, message: "Please Select School Code", isSuccess: false });
        return;
      }
      const width = window.screen.availWidth;
      const height = window.screen.availHeight;
      const url = `/SUPPORT/EL_ListWLPsRunningout?Subject=Mathematics&SchoolCode=${encodeURIComponent(selectedSchool.code)}&FamilyCode=${encodeURIComponent(selectedFamily)}&Login=${encodeURIComponent(selectedChild)}&Source=DE`;

      openBlockedWindow(
        url,
        'Default WLP running out - Maths',
        `width=${width},height=${height},resizable=yes,scrollbars=yes,status=yes`
      );
      // navigate(`/SUPPORT/EL_ListWLPsRunningout?Subject=Mathematics&SchoolCode=${encodeURIComponent(selectedSchool.code)}&FamilyCode=${encodeURIComponent(selectedFamily)}&Login=${encodeURIComponent(selectedChild)}`);
      return;
    }
    if (item.label === "Default WLP running out - English") {
      // if (!selectedSchool || !selectedSchool.code || !selectedChild || !selectedChildLogin) {
      //   setAlertInfo({ show: true, message: "Please Select required user", isSuccess: false });
      //   return;
      // }
      if (!selectedSchool || !selectedSchool.code) {
        setAlertInfo({ show: true, message: "Please Select School Code", isSuccess: false });
        return;
      }
      const width = window.screen.availWidth;
      const height = window.screen.availHeight;

      const url = `/SUPPORT/EL_ListWLPsRunningout?Subject=English&SchoolCode=${encodeURIComponent(selectedSchool.code)}&FamilyCode=${encodeURIComponent(selectedFamily)}&Login=${encodeURIComponent(selectedChild)}&Source=DE`;

      openBlockedWindow(
        url,
        'Default WLP running out - English',
        `width=${width},height=${height},resizable=yes,scrollbars=yes,status=yes`
      );

      // navigate(`/SUPPORT/EL_ListWLPsRunningout?Subject=English&SchoolCode=${encodeURIComponent(selectedSchool.code)}&FamilyCode=${encodeURIComponent(selectedFamily)}&Login=${encodeURIComponent(selectedChild)}`);
      return;
    }
    if (item.label === "MathsDoctor WLP running out") {
      if (!selectedSchool || !selectedSchool.code) {
        setAlertInfo({ show: true, message: "Please Select School Code", isSuccess: false });
        return;
      }
      // if (!selectedSchool || !selectedSchool.code || !selectedChild || !selectedChildLogin) {
      //   setAlertInfo({ show: true, message: "Please Select required user", isSuccess: false });
      //   return;
      // }
      const width = window.screen.availWidth;
      const height = window.screen.availHeight;

      const url = `/SUPPORT/EL_ListWLPsRunningout?Subject=Mathematics&SchoolCode=${encodeURIComponent(selectedSchool.code)}&FamilyCode=${encodeURIComponent(selectedFamily)}&Login=${encodeURIComponent(selectedChild)}&Source=MD`;

      openBlockedWindow(
        url,
        'MathsDoctor WLP running out',
        `width=${width},height=${height},resizable=yes,scrollbars=yes,status=yes`
      );
      // navigate(`/SUPPORT/EL_ListWLPsRunningout?Subject=Mathematics&SchoolCode=${encodeURIComponent(selectedSchool.code)}&FamilyCode=${encodeURIComponent(selectedFamily)}&Login=${encodeURIComponent(selectedChild)}`);
      return;
    }

    if (item.label === 'User Diary') {
      if (
        !selectedSchool ||
        !selectedSchool.code ||
        !selectedChild ||
        !selectedChildLogin
      ) {
        setAlertInfo({
          show: true,
          message: "Please select user.",
          isSuccess: false
        });
        return;
      }

      const url =
        `/STUDENT/Reports/EL_UserDiary` +
        `?SchoolCode=${encodeURIComponent(selectedSchool.code)}` +
        `&FamilyCode=${encodeURIComponent(selectedFamily)}` +
        `&Login=${encodeURIComponent(selectedChild)}` +
        `&CalledFrom=SysAdmin`;

      const width = window.screen.availWidth;
      const height = window.screen.availHeight;

      openBlockedWindow(
        url,
        "User Diary",
        `width=${width},height=${height},top=0,left=0,resizable=yes,scrollbars=yes,status=yes`
      );

      return;
    }


    if (item.label === "PT Report") {
      if (
        !selectedSchool ||
        !selectedSchool.code ||
        !selectedChild ||
        !selectedChildLogin
      ) {
        setAlertInfo({
          show: true,
          message: "Please select user.",
          isSuccess: false
        });
        return;
      }

      const url =
        `/STUDENT/Reports/EL_PTReport` +
        `?SchoolCode=${encodeURIComponent(selectedSchool.code)}` +
        `&FamilyCode=${encodeURIComponent(selectedFamily)}` +
        `&Login=${encodeURIComponent(selectedChild)}` +
        `&CalledFrom=SysAdmin`;

      const width = window.screen.availWidth;
      const height = window.screen.availHeight;

      openBlockedWindow(
        url,
        "PT Report",
        `width=${width},height=${height},top=0,left=0,resizable=yes,scrollbars=yes,status=yes`
      );

      return;
    }

    // if (item.label === "Knowledge Gap Report") {
    //   if (!selectedSchool || !selectedSchool.code || !selectedChild || !selectedChildLogin) {
    //     setAlertInfo({ show: true, message: "Please Select required Student", isSuccess: false });
    //     return;
    //   }
    //   navigate(`/MD_Reports/MD_EReport_PDF?SchoolCode=${encodeURIComponent(selectedSchool.code)}&FamilyCode=${encodeURIComponent(selectedFamily)}&Login=${encodeURIComponent(selectedChild)}`);
    //   return;
    // }
    // if (item.label === "Navigation Report") {
    //   if (!selectedSchool || !selectedSchool.code || !selectedChild || !selectedChildLogin) {
    //     setAlertInfo({ show: true, message: "Please Select required Student", isSuccess: false });
    //     console.log('$$$$$$$')
    //     return;
    //   }
    //   if (!selectedReport) {
    //     setAlertInfo({ show: true, message: "Please Select required Report", isSuccess: false });
    //     return;
    //   }
    //   console.log('%%%%%%%')
    //   navigate(`/MD_Reports/MD_NavReport?StuSch=EL_${encodeURIComponent(selectedSchool.code)}&StuFam=${encodeURIComponent(selectedFamily)}&StudentId=${encodeURIComponent(selectedChild)}&ReportNo=${encodeURIComponent(selectedReport)}`);
    //   console.log('', `/MathsDoctor/Reports/NavigationReport?SchoolCode=${encodeURIComponent(selectedSchool.code)}&FamilyCode=${encodeURIComponent(selectedFamily)}&Login=${encodeURIComponent(selectedChild)}`)
    //   return;
    // }

    if (item.label === "Navigation Report") {
      if (
        !selectedSchool ||
        !selectedSchool.code ||
        !selectedChild ||
        !selectedChildLogin
      ) {
        setAlertInfo({
          show: true,
          message: "Please Select required Student",
          isSuccess: false
        });
        return;
      }

      if (!selectedReport) {
        setAlertInfo({
          show: true,
          message: "Please Select required Report",
          isSuccess: false
        });
        return;
      }

      const url =
        `/MD_Reports/MD_NavReport` +
        `?StuSch=EL_${encodeURIComponent(selectedSchool.code)}` +
        `&StuFam=${encodeURIComponent(selectedFamily)}` +
        `&StudentId=${encodeURIComponent(selectedChild)}` +
        `&ReportNo=${encodeURIComponent(selectedReport)}`;

      const width = window.screen.availWidth;
      const height = window.screen.availHeight;

      openBlockedWindow(
        url,
        'MD Navigation Report',
        `width=${width},height=${height},top=0,left=0,resizable=yes,scrollbars=yes,status=yes`
      );

      return;
    }


    if (item.label === "EC Navigation Report") {
      if (
        !selectedSchool ||
        !selectedSchool.code ||
        !selectedChild ||
        !selectedChildLogin
      ) {
        setAlertInfo({
          show: true,
          message: "Please Select required Student",
          isSuccess: false
        });
        return;
      }

      if (!selectedReport) {
        setAlertInfo({
          show: true,
          message: "Please Select required Report",
          isSuccess: false
        });
        return;
      }

      const url =
        `/EC_Reports/EC_NavReport` +
        `?StuSch=EL_${encodeURIComponent(selectedSchool.code)}` +
        `&StuFam=${encodeURIComponent(selectedFamily)}` +
        `&StudentId=${encodeURIComponent(selectedChild)}` +
        `&ReportNo=${encodeURIComponent(selectedReport)}`;

      const width = window.screen.availWidth;
      const height = window.screen.availHeight;

      openBlockedWindow(
        url,
        "EC Navigation Report",
        `width=${width},height=${height},top=0,left=0,resizable=yes,scrollbars=yes,status=yes`
      );

      return;
    }


    // if (item.label === "Current WLP Report") {
    //   if (!selectedSchool || !selectedSchool.code || !selectedChild || !selectedChildLogin) {
    //     setAlertInfo({ show: true, message: "Please Select required Student", isSuccess: false });
    //     return;
    //   }
    //   navigate(`/MD_Reports/MD_WPReport_PDF/?SchoolCode=${encodeURIComponent(selectedSchool.code)}&FamilyCode=${encodeURIComponent(selectedFamily)}&Login=${encodeURIComponent(selectedChild)}`);
    //   return;
    // }
    // if (item.label === "Performance Report") {
    //   if (!selectedSchool || !selectedSchool.code || !selectedChild || !selectedChildLogin) {
    //     setAlertInfo({ show: true, message: "Please Select required Student", isSuccess: false });
    //     return;
    //   }
    //   navigate(`/MD_Reports/MD_WeeklyPerformanceReport/?SchoolCode=${encodeURIComponent(selectedSchool.code)}&FamilyCode=${encodeURIComponent(selectedFamily)}&Login=${encodeURIComponent(selectedChild)}`);
    //   return;
    // }


    if (item.label === "New MD PDF Report") {
      if (!selectedSchool || !selectedSchool.code || !selectedChild || !selectedChildLogin) {
        setAlertInfo({ show: true, message: "Please Select required Student", isSuccess: false });
        return;
      }
      if (!selectedReport) {
        setAlertInfo({ show: true, message: "Please Select required Report", isSuccess: false });
        return;
      }
      const width = window.screen.availWidth;
      const height = window.screen.availHeight;

      const url = `/MathsDoctor/Reports/PDFReport/?SchoolCode=${encodeURIComponent(selectedSchool.code)}&FamilyCode=${encodeURIComponent(selectedFamily)}&Login=${encodeURIComponent(selectedChild)}&ReportNo=${encodeURIComponent(selectedReport)}`;

      openBlockedWindow(
        url,
        'MD PDF Report',
        `width=${width},height=${height},resizable=yes,scrollbars=yes,status=yes`
      );
      // navigate(`/MathsDoctor/Reports/PDFReport/?SchoolCode=${encodeURIComponent(selectedSchool.code)}&FamilyCode=${encodeURIComponent(selectedFamily)}&Login=${encodeURIComponent(selectedChild)}`);
      return;
    }

    if (item.label === "New EC PDF Report") {
      if (!selectedSchool || !selectedSchool.code || !selectedChild || !selectedChildLogin) {
        setAlertInfo({ show: true, message: "Please Select required Student", isSuccess: false });
        return;
      }
      if (!selectedReport) {
        setAlertInfo({ show: true, message: "Please Select required Report", isSuccess: false });
        return;
      }
      const width = window.screen.availWidth;
      const height = window.screen.availHeight;

      const url = `/EnglishCheck/Reports/EPDFReport/?SchoolCode=${encodeURIComponent(selectedSchool.code)}&FamilyCode=${encodeURIComponent(selectedFamily)}&Login=${encodeURIComponent(selectedChild)}&ReportNo=${encodeURIComponent(selectedReport)}`;

      openBlockedWindow(
        url,
        'MD PDF Report',
        `width=${width},height=${height},resizable=yes,scrollbars=yes,status=yes`
      );
      // navigate(`/MathsDoctor/Reports/PDFReport/?SchoolCode=${encodeURIComponent(selectedSchool.code)}&FamilyCode=${encodeURIComponent(selectedFamily)}&Login=${encodeURIComponent(selectedChild)}`);
      return;
    }



    if (item.label === "Still Report") {
      if (!selectedSchool || !selectedSchool.code || !selectedChild || !selectedChildLogin) {
        setAlertInfo({ show: true, message: "Please Select required Student", isSuccess: false });
        return;
      }
      if (!selectedReport) {
        setAlertInfo({ show: true, message: "Please Select required Report", isSuccess: false });
        return;
      }

      const width = window.screen.availWidth;
      const height = window.screen.availHeight;
      const url = `/MathsDoctor/Reports/StillReport/?SchoolCode=${encodeURIComponent(selectedSchool.code)}&FamilyCode=${encodeURIComponent(selectedFamily)}&Login=${encodeURIComponent(selectedChild)}&ReportNo=${encodeURIComponent(selectedReport)}`;

      openBlockedWindow(
        url,
        'Still Report',
        `width=${width},height=${height},resizable=yes,scrollbars=yes,status=yes`
      )
      // navigate(`/MathsDoctor/Reports/StillReport/?SchoolCode=${encodeURIComponent(selectedSchool.code)}&FamilyCode=${encodeURIComponent(selectedFamily)}&Login=${encodeURIComponent(selectedChild)}&ReportNo=${encodeURIComponent(selectedReport)}`);
      return;
    }
    // if (item.label === "Moving Report") {
    //   if (!selectedSchool || !selectedSchool.code || !selectedChild || !selectedChildLogin) {
    //     setAlertInfo({ show: true, message: "Please Select required Student", isSuccess: false });
    //     return;
    //   }
    //   navigate(`/MathsDoctor/Reports/MovingReport/?SchoolCode=${encodeURIComponent(selectedSchool.code)}&FamilyCode=${encodeURIComponent(selectedFamily)}&Login=${encodeURIComponent(selectedChild)}`);
    //   return;
    // }

    if (item.label === 'Courtesy Call List') {
      // Fallbacks to sessionStorage if no specific user is selected in the dropdowns, 
      // matching the legacy behavior you observed (S=A, F=AA, L=shubhanga)
      const sCode = selectedSchool?.code || sessionStorage.getItem('S') || 'A';
      const fCode = selectedFamily || sessionStorage.getItem('F') || 'AA';
      const userLogin = loginId || sessionStorage.getItem('L') || '';

      // If strict selection is required before navigating, uncomment the validation below:
      /*
      if (!sCode || !fCode || !userLogin) {
        setAlertInfo({ show: true, message: "Please select School, Family, and Login first.", isSuccess: false });
        return;
      }
      */

      const url = `/SUPPORT/EL_CourtesyCallList?FilterType=CSCourtesyCall&S=${encodeURIComponent(sCode)}&F=${encodeURIComponent(fCode)}&L=${encodeURIComponent(userLogin)}`;
      navigate(url);
      return;
    }

    if (item.label === 'Add DNC') {
      setShowAddDNC(true);
      return;
    }

    if (item.label === 'Search DNC') {
      setShowSearchDNC(true);
      return;
    }

    if (item.label === 'Extension Student') {
      const width = 1050;
      const height = 850;
      const left = (window.screen.availWidth - width) / 2;
      const top = (window.screen.availHeight - height) / 2;

      const url = `${item.navigation}?CalledFrom=SysAdmin`;

      const newWindow = window.open(
        url,
        'ExtensionStudent',
        `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`
      );

      if (newWindow) {
        const timer = setInterval(() => {
          if (newWindow.closed) {
            clearInterval(timer);
          }
        }, 500);
      }
      return;
    }

    if (item.label === 'Manage States') {
      const width = 600;
      const height = 400;
      const left = (window.screen.availWidth - width) / 2;
      const top = (window.screen.availHeight - height) / 2;

      const url = item.navigation || '/WebAdmin/Admin/EL_ManageStates';

      openBlockedWindow(
        url,
        'ManageStates',
        `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`
      );
      return;
    }

    if (item.navigation) {
      navigate(item.navigation);
    }
  };

  useEffect(() => {
    document.body.style.backgroundColor = '#214461';
    fetch_activeusercount();
    fetchCountries();
    setIsMobile(window.innerWidth < 768);
    setSiteMode('LIVE');
    setShowButtonsPanel(true);
    setShowLoginPanel(false);
  }, []);

  useEffect(() => {
    if (selectedCountry) {
      fetchSchoolCodes(selectedCountry, schoolType);
      sessionStorage.setItem("category", schoolType);
    }
  }, [selectedCountry, schoolType]);


  // useEffect(() => {
  //   if (!selectedChild) return;

  //   setDropdownResponse(true);

  //   fetch(`${API_BASE_URL}api/get_md_reports/`, {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     body: JSON.stringify({
  //       schoolcode: selectedSchool?.code,
  //       familycode: selectedFamily,
  //       login: selectedChild
  //     }),
  //   })
  //     .then(r => r.json())
  //     .then(data => {
  //       setMdReports(data);
  //     })
  //     .catch(err => {
  //       console.error('Error fetching MD reports:', err);
  //     })
  //     .finally(() => {
  //       setDropdownResponse(false); 
  //     });

  // }, [selectedChild]);

  useEffect(() => {
    if (!selectedChild) return;

    const controller = new AbortController();
    const { signal } = controller;

    setDropdownResponse(true);

    fetch(`${API_BASE_URL}api/get_md_reports/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        schoolcode: selectedSchool?.code,
        familycode: selectedFamily,
        login: selectedChild,
      }),
      signal,
    })
      .then(r => r.json())
      .then(data => {
        setMdReports(data || []);

        // Reset MD selection when child changes
        setSelectedMDReport('');
      })
      .catch(err => {
        if (err.name !== 'AbortError') {
          console.error('Error fetching MD reports:', err);
        }
      })
      .finally(() => {
        if (!signal.aborted) {
          setDropdownResponse(false);
        }
      });

    return () => controller.abort();
  }, [selectedChild]);




  useEffect(() => {
    if (!selectedChild) return;

    const controller = new AbortController();

    fetch(`${API_BASE_URL}api/get_ec_reports/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        schoolcode: selectedSchool?.code,
        familycode: selectedFamily,
        login: selectedChild,
      }),
      signal: controller.signal,
    })
      .then(r => r.json())
      .then(data => {
        setEcReports(data || []);

        // Reset EC selection when child changes
        setSelectedECReport('');
      })
      .catch(err => {
        if (err.name !== 'AbortError') {
          console.error('Error fetching EC reports:', err);
        }
      });

    return () => controller.abort();
  }, [selectedChild]);


  return (
    <>
      {showSalesReport ? (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 9999, backgroundColor: 'white' }}>
          <KMDistributorSalesReport onBack={() => setShowSalesReport(false)} />
        </div>
      ) : showSchoolUsage ? (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 9999, backgroundColor: 'white' }}>
          <EL_SchoolUsage onBack={() => setShowSchoolUsage(false)} />
        </div>
      )
        // : showLoginUsage ? (
        //   <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 9999, backgroundColor: 'white' }}>
        //     <EL_LoginUsage
        //       schoolCode={selectedSchool?.code}
        //       familyCode={selectedFamily || ''}
        //       login={selectedChild || ''}
        //       onBack={() => setShowLoginUsage(false)}
        //     />
        //   </div>
        // )
        : (
          <div style={{ margin: '2px', fontFamily: 'Trebuchet MS', fontSize: '10pt', color: 'white' }}>
            {isBlocked && <div style={disabledOverlayStyle} />}
            {dropdownResponse && (
              <div
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 1000,
                }}
              >
                {/* <div
            style={{
              backgroundColor: '#ffffcc',
              padding: '20px',
              borderRadius: '5px',
              fontWeight: 'bold',
              color: 'blue',
            }}
          >
            Please wait...
          </div> */}
                <Loading />
              </div>
            )}

            <center style={{ boxSizing: "content-box" }}>
              <div id="divSysAdmin" style={{ position: 'relative', background: `url(${MasterBKG})`, backgroundRepeat: 'no-repeat', width: '800px', height: '900px', overflow: 'hidden', marginTop: '5px', cursor: dropdownResponse ? 'wait' : '', }}>
                <div style={{ height: '60px', paddingTop: '70px' }}>
                  <table style={{ width: '100%', fontFamily: 'Arial', color: 'white', fontWeight: 'bold' }}>
                    <tbody>
                      <tr>
                        <td style={{ paddingLeft: "40px", textAlign: "left" }}>
                          <span
                            style={{
                              backgroundColor: "yellow",
                              color: "red",
                              fontFamily: "Arial",
                              fontSize: "11pt",
                              padding: "2px 5px",
                            }}
                          >
                            Development
                          </span>
                          &nbsp;V2&nbsp;&nbsp;
                        </td>

                        <td>
                          <span
                            style={{
                              backgroundColor: "yellow",
                              color: "red",
                              fontFamily: "Arial",
                              fontSize: "11pt",
                              padding: "2px 5px",
                            }}
                          >
                            {window.location.hostname === "sysadmin.elearnoncloud.com" ||
                              window.location.hostname === "www.elearnoncloud.com"
                              ? "PRODUCTION"
                              : window.location.hostname === "staging.sysadmin.elearnoncloud.com"
                                ? "STAGING"
                                : "TESTING"}
                          </span>
                        </td>

                        <td style={{ textAlign: "end", fontSize: "12pt" }}>
                          {new Intl.DateTimeFormat("en-GB", {
                            weekday: "short",
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false,
                            timeZone: "UTC",
                          })
                            .format(new Date())
                            .replace(",", "") + " UTC"}
                        </td>
                        <td style={{ paddingRight: '40px', textAlign: 'right' }}>
                          <a href="/" style={{ color: 'blue', fontSize: '12pt' }} onClick={() => { sessionStorage.clear(); }}>Logout</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div style={{ padding: '5px', display: 'flex', gap: '10px', justifyContent: 'center' }}>

                    {/* */}
                    {/* {['Admin', 'Data', 'Support', 'Reports', ...(isSuperAdminUser ? ['SuperAdmin'] : []), 'Analysis'] */}
                    {/*AUGUST 4 2026 --- SuperAdmin Issue Fixed*/}
                    {['Admin', 'Data', 'Support', 'Reports', ...(canShowMenuItem('98') ? ['SuperAdmin'] : []), 'Analysis']
                      .filter(menu => {
                        if (menu === 'LessonBrowser') return true;
                        return Object.values(groupMenuItemsBySection(menus[menu])).some(sectionItems =>
                          sectionHasVisibleItems(sectionItems)
                        );
                      })
                      .map(menu => {
                        const hasDropdown = menusWithDropdown.includes(menu) &&
                          Object.values(groupMenuItemsBySection(menus[menu])).some(sectionItems =>
                            sectionHasVisibleItems(sectionItems)
                          );

                        return (
                          <div
                            key={menu}
                            className="menuWrapper"
                            style={{ position: 'relative' }}
                            onMouseEnter={hasDropdown ? () => setActiveMenu(menu) : undefined}
                            onMouseLeave={hasDropdown ? () => setActiveMenu(null) : undefined}
                          >
                            <button
                              className="cssButtonWithBorder"
                              style={{ color: 'white', padding: '5px 20px', width: 'auto', whiteSpace: 'nowrap', display: 'inline-flex' }}
                              onClick={() => {
                                if (menu === 'LessonBrowser') {
                                }
                              }}
                            >
                              {menu
                                .replace('SuperAdmin', 'Super Admin')
                                .replace('LessonBrowser', 'Lesson browser')
                              }
                            </button>
                            {hasDropdown && activeMenu === menu && (
                              <div className="hoverMenu">
                                {Object.entries(groupMenuItemsBySection(menus[menu])).map(([sectionLabel, sectionItems]) => {
                                  if (!sectionHasVisibleItems(sectionItems)) {
                                    return null;
                                  }

                                  return (
                                    <React.Fragment key={sectionLabel}>
                                      {sectionLabel != "Default" && (
                                        <div
                                          className="hoverMenuHeader"
                                          style={{
                                            color: 'maroon',
                                            fontSize: '13px',
                                            fontWeight: 'bold',
                                            textDecoration: 'underline',
                                          }}
                                        >
                                          {sectionLabel == "Default" ? "" : sectionLabel}
                                        </div>
                                      )}
                                      {sectionItems.map((childItem, childIdx) => {
                                        if (canShowMenuItem(childItem.code)) {
                                          return (
                                            <div
                                              key={childIdx}
                                              className="hoverMenuItem"
                                              style={{
                                                // color: 'blue',
                                                color: childItem.status === 'C' ? 'blue' : childItem.status === 'D' ? 'gray' : 'red',
                                                fontSize: '13px',
                                                fontWeight: 'normal',
                                                textDecoration: 'none',
                                                lineHeight: '12px',
                                              }}
                                              onClick={() => handleNavigation(childItem)}
                                            >
                                              {childItem.label}
                                            </div>
                                          );
                                        }
                                        return null;
                                      })}
                                    </React.Fragment>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        );
                      })}
                  </div>
                  {/* {hasNonSupportMenu && (
                      <div style={{ height: '10px', paddingBottom: '10px', textAlign: 'center', cursor: dropdownResponse ? 'wait' : 'pointer', textDecoration: 'underline', color: 'blue', fontSize: "11pt" }} >
                        Site Status&nbsp;<span id="spnSiteMode" style={{ color: 'Red', fontWeight: 'bolder', textDecorationLine: 'none' }}
                        //  onClick={handleConfirmAndSetSiteMode}
                        >{siteMode}</span>
                      </div>
                    )} */}
                </div>

                {showLoginPanel && (
                  <div style={{ width: '300px', margin: '20px auto' }}>
                    <table style={{ width: '100%', fontFamily: 'Trebuchet MS', fontSize: '10pt', color: '#3264a0', border: 'dotted 1px black', backgroundColor: '#CCCCFF', margin: '0 auto' }}>
                      <tbody>
                        <tr>
                          <td colSpan={3} style={{ textAlign: 'center', verticalAlign: 'middle', height: '50px' }}>Authenticate Yourself</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: 'right', height: '20px', width: '35%' }}>&nbsp;Login ID:&nbsp;</td>
                          <td style={{ textAlign: 'left', height: '20px', width: '60%' }}>&nbsp;<input type="text" value={loginId} onChange={(e) => setLoginId(e.target.value)} style={{ width: '90%' }} /></td>
                          <td style={{ height: '35px', width: '5%' }}></td>
                        </tr>
                        <tr style={{ height: '5px' }}>
                          <td colSpan={3} style={{ height: '5px' }}></td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: 'right', height: '20px', width: '35%' }}>&nbsp;Password:&nbsp;</td>
                          <td style={{ textAlign: 'left', height: '20px', width: '60%' }}>&nbsp;<input type="password" value={password} onChange={(e) => setPassword(e.target.value)} style={{ width: '90%' }} /></td>
                          <td style={{ height: '20px', width: '5%' }}></td>
                        </tr>
                        <tr>
                          <td colSpan={3} style={{ textAlign: 'center', verticalAlign: 'middle', height: '20px', width: '100%' }}>
                            <input type="checkbox" />&nbsp;Remember Me
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={3} style={{ textAlign: 'center', verticalAlign: 'middle', height: '20px', width: '100%' }}>
                            <a href="#" onClick={handleForgotPassword}>Forgot Password?</a>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={3} style={{ textAlign: 'center', verticalAlign: 'middle', height: '50px', width: '100%' }}>
                            <button onClick={handleLogin} style={{ backgroundImage: "url('Images/login_n.gif')", border: 'none', width: '80px', height: '30px' }}></button>
                            &nbsp;&nbsp;
                            <button onClick={handleCancel} style={{ backgroundImage: "url('Images/cancel_n.gif')", border: 'none', width: '80px', height: '30px' }}></button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}

                {showButtonsPanel && hasNonSupportMenu && (
                  // <div style={{ paddingTop: '20px', width: '720px', backgroundImage: `url(${SysAdminBkg})`, cursor: dropdownResponse ? 'wait' : '' }}>
                  <div style={{ width: '720px', backgroundImage: `url(${SysAdminBkg})`, cursor: dropdownResponse ? 'wait' : '' }}>
                    <table style={{ width: '100%', verticalAlign: 'top', margin: '0px auto', borderTop: '1px solid blue', borderLeft: '1px solid blue', borderRight: '1px solid blue' }}>
                      <tbody style={{ color: '#000' }}>
                        <tr>
                          <td style={{ width: '16%', borderBottom: 'none', borderRight: 'none', fontSize: '11pt', textAlign: 'left' }}>&nbsp;<span style={{ fontWeight: 'bold' }}>NOW:</span></td>
                          <td style={{ width: '84%', borderLeft: 'none', borderBottom: 'none', fontSize: '11pt', textAlign: 'left', verticalAlign: 'middle' }}>
                            {/* Active Users: <button className="cssButtonForAdmin" disabled={true} onClick={() => { window.location.href = '/WEBADMIN/REPORTS/EL_ShowCurrentLogins' }}> */}
                            Active Users: <button className="cssButtonForAdmin" onClick={() => { window.location.href = '/WEBADMIN/REPORTS/EL_ShowCurrentLogins' }}>
                              {activeUsers}
                            </button>&nbsp;&nbsp;Connections: <span style={{ color: 'teal', fontWeight: 'bold' }}>{connections}</span>&nbsp;&nbsp;&nbsp;
                          </td>
                        </tr>
                        <tr>
                          <td style={{ borderTop: 'none', borderRight: 'none', fontSize: '11pt', textAlign: 'left' }}>&nbsp;<span style={{ fontWeight: 'bold' }}>TODAY:</span></td>
                          <td style={{ borderLeft: 'none', borderTop: 'none', fontSize: '11pt', textAlign: 'left', verticalAlign: 'middle' }}>
                            ErrorLog: <button className="cssButtonForAdmin" onClick={() => { window.location.href = '/WEBADMIN/REPORTS/EL_ShowErrorLog' }} style={{ width: '120px', fontWeight: 'bold' }}>
                              {errorLog}
                            </button>&nbsp;&nbsp;&nbsp;&nbsp;Total Logged users = <span style={{ color: 'Blue', fontWeight: 'bold' }}>{totalLoggedUsers}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <table style={{ width: '100%', border: 'solid 1px blue', borderTop: '1px solid blue', margin: '0px auto', color: '#000' }}>
                      <tbody>
                        <tr>
                          <td style={{ width: '50%', verticalAlign: 'top', borderRight: 'solid 1px blue' }}>
                            <table style={{ width: '98%', margin: '0 auto' }}>
                              <tbody>
                                <tr>
                                  <td style={{ width: '35%', borderBottom: 'solid 1px white', borderRight: 'solid 1px white', height: '20px', textAlign: 'left' }} className="cssLabelOptional">Country</td>
                                  <td id="tdCountries" colSpan={2} style={{ width: '65%', height: '20px', textAlign: 'left', color: "black" }}>
                                    <select
                                      id="ddlCountry"
                                      onChange={handleCountryChange}
                                      value={selectedCountry}
                                      style={{
                                        width: '100%',
                                        color: 'black',
                                        backgroundColor: 'white'
                                      }}
                                    >
                                      {countries.map(country => (
                                        <option key={country} value={country}>
                                          {country}
                                        </option>
                                      ))}
                                    </select>
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={3} style={{ height: '28px', verticalAlign: 'middle', fontFamily: 'Arial', fontSize: '11pt', backgroundColor: '#ffffcc', textAlign: 'left' }}>
                                    <input type="checkbox" id="chkActive" checked={isActiveOnly} onChange={handleActiveChange} />&nbsp;Active
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={3} style={{ height: '28px', verticalAlign: 'middle', fontFamily: 'Arial', fontSize: '11pt', backgroundColor: '#ffffcc', textAlign: 'left' }}>
                                    {schoolCategories.map(cat => (
                                      <span key={cat.value}>
                                        <input type="radio" style={{ marginBottom: '5px' }} id={`rdo${cat.value}`} name="rdoSLID" value={cat.value} checked={schoolType === cat.value} onChange={handleSchoolTypeChange} />{cat.label}&nbsp;&nbsp;&nbsp;&nbsp;
                                      </span>
                                    ))}
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: '35%', borderBottom: 'solid 1px white', borderRight: 'solid 1px white', textAlign: 'left' }} className="cssLabelOptional">
                                    {schoolCategories.find(cat => cat.value === schoolType)?.label} Code
                                  </td>
                                  <td style={{ width: '50%', textAlign: 'left' }}>
                                    <select id="ddlSchools" onChange={handleSchoolSelect} style={{ width: '100%' }} value={selectedSchool?.code || ''} >
                                      {/* <option>--Select--</option> */}
                                      {apiSchools.map(s => (
                                        <option key={s.schoolcode} value={s.schoolcode}>
                                          {s.schoolcode}
                                        </option>
                                      ))}
                                    </select>
                                  </td>
                                  <td style={{ width: '15%', textAlign: 'center' }}>
                                    <button
                                      className="cssButtonForAdmin"
                                      onClick={() => {
                                        if (!selectedSchool?.code) {
                                          setAlertInfo({
                                            show: true,
                                            message: "Please select a School first",
                                            isSuccess: false,
                                          });
                                          return;
                                        }

                                        navigate(
                                          `/WebAdmin/SCHOOLS/EL_SchoolDetails?SchoolCode=${encodeURIComponent(
                                            selectedSchool.code
                                          )}&CalledFrom=S`
                                        );
                                      }}
                                    >
                                      Edit
                                    </button>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ borderBottom: 'solid 1px white', borderRight: 'solid 1px white', height: '20px', textAlign: 'left' }} className="cssLabelOptional">Admin / Staff</td>
                                  <td colSpan={1} style={{ height: '20px', textAlign: 'left' }}>
                                    <select id="ddlAdmins" onChange={handleAdminSelect} style={{ width: '100%', color: '#802CFF', fontWeight: 'bold' }}>
                                      <option>--Select--</option>
                                      {admins.map(admin => (
                                        <option key={admin.login} style={{ color: admin.category === 'DA' ? 'red' : admin.category.trim() === 'T' ? '#000' : '#802CFF' }} value={admin.login}>
                                          {admin.login}
                                        </option>
                                      ))}
                                    </select>
                                  </td>
                                  <td style={{ textAlign: 'center' }}><span style={{ color: 'Blue', fontWeight: 'bold' }}>{admins.length}</span></td>
                                </tr>
                                <tr>
                                  <td style={{ borderBottom: 'solid 1px white', borderRight: 'solid 1px white', height: '20px', textAlign: 'left' }} className="cssLabelOptional">Families</td>
                                  <td colSpan={1} style={{ height: '20px', textAlign: 'left' }}>
                                    <select id="ddlFamilies" onChange={handleFamilySelect} style={{ width: '100%', color: '#0000FF', fontWeight: 'bold' }}>
                                      <option>--Select--</option>
                                      {families.map(family => (
                                        <option key={family.login} value={family.login}>{family.login}</option>
                                      ))}
                                    </select>
                                  </td>
                                  <td style={{ textAlign: 'center' }}><button className="cssButtonForAdmin" style={{ width: '40px', fontWeight: 'bold' }}>{families.length}</button></td>
                                </tr>
                                <tr>
                                  <td style={{ borderBottom: 'solid 1px white', borderRight: 'solid 1px white', height: '20px', textAlign: 'left' }} className="cssLabelOptional">Children</td>
                                  <td colSpan={1} style={{ height: '20px', textAlign: 'left' }}>
                                    <select id="ddlChildren" onChange={handleChildSelect} style={{ width: '100%', color: '#800000', fontWeight: 'bold' }}>
                                      <option>--Select--</option>
                                      {children.map(child => (
                                        <option key={child.name} value={child.login}>{child.name}</option>
                                      ))}
                                    </select>
                                  </td>
                                  <td style={{ textAlign: 'center' }}><span style={{ color: 'Blue', fontWeight: 'bold' }}>{children.length}</span></td>
                                </tr>
                                <tr>
                                  <td style={{ borderBottom: 'solid 1px white', borderRight: 'solid 1px white', height: '20px', textAlign: 'left' }} className="cssLabelOptional">Teachers</td>
                                  <td colSpan={1} style={{ height: '20px', textAlign: 'left' }}>
                                    <select id="ddlTeachers" onChange={handleTeacherSelect} style={{ width: '100%', color: '#008080', fontWeight: 'bold' }}>
                                      <option>--Select--</option>
                                      {teachers.map(teacher => (
                                        <option key={teacher.login} value={teacher.login}>{teacher.login}</option>
                                      ))}
                                    </select>
                                  </td>
                                  <td style={{ textAlign: 'center' }}><span style={{ color: 'Blue', fontWeight: 'bold' }}>{teachers.length}</span></td>
                                </tr>
                                <tr>
                                  <td style={{ borderBottom: 'solid 1px white', borderRight: 'solid 1px white', height: '20px', textAlign: 'left' }} className="cssLabelOptional">
                                    {schoolCategories.find(cat => cat.value === schoolType)?.label === 'School' ? 'Students' : 'Users'}
                                  </td>
                                  <td colSpan={1} style={{ height: '20px', textAlign: 'left' }}>
                                    <select id="ddlStudents" onChange={handleStudentSelect} style={{ width: '100%', color: '#000000', fontWeight: 'bold' }}>
                                      <option>--Select--</option>
                                      {students.map(student => (
                                        <option key={student.login} value={student.login}>{student.login}</option>
                                      ))}
                                    </select>
                                  </td>
                                  <td style={{ textAlign: 'center' }}><button className="cssButtonForAdmin" style={{ width: '40px', fontWeight: 'bold' }}>{students.length}</button></td>
                                </tr>
                                <tr>
                                  <td style={{ borderBottom: 'solid 1px white', borderRight: 'solid 1px white', height: '20px', textAlign: 'left' }} className="cssLabelOptional">Login</td>
                                  <td colSpan={1}><input type="text" id="txtLog" value={loginId} onChange={(e) => setLoginId(e.target.value)} style={{ width: '97%', border: 'solid 1px #003300' }} /></td>
                                  <td>&nbsp;</td>
                                </tr>
                                <tr>
                                  <td style={{ borderBottom: 'solid 1px white', borderRight: 'solid 1px white', height: '20px', textAlign: 'left' }} className="cssLabelOptional">Password</td>
                                  <td colSpan={1}><input type="text" id="txtPassword" value={password} onChange={(e) => setPassword(e.target.value)} style={{ width: '97%', border: 'solid 1px #003300' }} /></td>
                                  <td>&nbsp;</td>
                                </tr>
                                <tr>
                                  <td
                                    style={{
                                      borderBottom: 'solid 1px white',
                                      borderRight: 'solid 1px white',
                                      height: '20px',
                                      textAlign: 'left'
                                    }}
                                    className="cssLabelOptional"
                                  >
                                    MD Reports
                                  </td>

                                  <td id="tdMD">
                                    <select
                                      id="ddlMD"
                                      value={selectedMDReport}
                                      onChange={handleMdReportSelect}
                                      style={{
                                        width: '100%',
                                        color: '#ff00ff'
                                      }}
                                    >
                                      <option value="">--Select--</option>

                                      {mdReports.map((report, index) => (
                                        <option
                                          key={report.reportno}
                                          value={String(report.reportno)}
                                        >
                                          {index + 1}) {formatReportDate(report.testcompletiondate)} {report.score}
                                        </option>
                                      ))}
                                    </select>
                                  </td>

                                  <td>&nbsp;</td>
                                </tr>

                                <tr>
                                  <td
                                    style={{
                                      borderBottom: 'solid 1px white',
                                      borderRight: 'solid 1px white',
                                      height: '20px',
                                      textAlign: 'left'
                                    }}
                                    className="cssLabelOptional"
                                  >
                                    EC Reports
                                  </td>

                                  <td id="tdEC">
                                    <select
                                      id="ddlEC"
                                      value={selectedECReport}
                                      onChange={handleECReportSelect}
                                      style={{
                                        width: '100%',
                                        color: '#ff00ff'
                                      }}
                                    >
                                      <option value="">--Select--</option>

                                      {ecReports.map((report, index) => (
                                        <option
                                          key={report.reportno}
                                          value={String(report.reportno)}
                                        >
                                          {index + 1}) {formatReportDate(report.testcompletiondate)} {report.score}
                                        </option>
                                      ))}
                                    </select>
                                  </td>

                                  <td>&nbsp;</td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td style={{ width: '50%', verticalAlign: 'top' }}>
                            <table id='table2' style={{ width: '100%', fontSize: '9pt' }}>
                              <tbody>
                                <tr>
                                  <td style={{ borderBottom: 'solid 1px blue', backgroundColor: '#E0E0E0', textAlign: 'left' }} colSpan={2}>&nbsp;Details of&nbsp;&nbsp;<span id="spnSchoolCode" style={{ fontWeight: 'bold', fontFamily: 'Arial', fontSize: '10pt', color: 'maroon' }}>{selectedSchool?.code}</span>&nbsp;&nbsp;(&nbsp;<span id="spnDLRorHO" style={{ fontWeight: 'bold', fontFamily: 'Arial', fontSize: '10pt', color: 'maroon' }}></span>&nbsp;)</td>
                                </tr>
                                <tr>
                                  <td style={{ textAlign: 'left', width: '35%' }}>&nbsp;Name:</td>
                                  <td style={{ textAlign: 'left', width: '65%' }}><span style={{ color: 'Blue', fontWeight: 'bold' }}>{selectedSchool?.name}</span></td>
                                </tr>
                                <tr>
                                  <td style={{ textAlign: 'left' }}>&nbsp;Status:</td>
                                  <td style={{ textAlign: 'left' }}><span style={{ color: 'Blue', fontWeight: 'bold' }}>{selectedSchool?.status}</span></td>
                                </tr>
                                <tr>
                                  <td style={{ textAlign: 'left' }}>&nbsp;Max Users / Seats:</td>
                                  <td style={{ textAlign: 'left' }}><span style={{ color: 'Blue', fontWeight: 'bold' }}>{selectedSchool?.maxUsers}</span>&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;<span style={{ color: 'Blue', fontWeight: 'bold' }}>{selectedSchool?.maxSeats}</span></td>
                                </tr>
                                <tr>
                                  <td style={{ borderTop: 'solid 1px blue', borderBottom: 'solid 1px blue', backgroundColor: '#E0E0E0', textAlign: 'left' }} colSpan={2}>&nbsp;Details of&nbsp;&nbsp;<span id="spnSelectedLogin" style={{ fontWeight: 'bold', fontFamily: 'Arial', fontSize: '10pt', color: 'maroon' }}>{selectedLogin?.login}</span></td>
                                </tr>
                                <tr>
                                  <td style={{ textAlign: 'left' }}>&nbsp;Name:</td>
                                  <td style={{ textAlign: 'left' }}><span id="spnName" style={{ color: 'Blue', fontWeight: 'bold' }}>{selectedLogin?.name}</span></td>
                                </tr>
                                <tr>
                                  <td style={{ textAlign: 'left' }}>&nbsp;Category / RegTyp:</td>
                                  <td style={{ textAlign: 'left' }}><span id="spnCategory" style={{ color: 'Blue', fontWeight: 'bold' }}>{getUserCategory()}</span>&nbsp;/&nbsp;<span id="spnHowAdded" style={{ color: 'Blue', fontWeight: 'bold' }}>{selectedLogin?.howAdded}</span></td>
                                </tr>
                                <tr>
                                  <td style={{ textAlign: 'left' }}>&nbsp;Status / Validity:</td>
                                  <td style={{ textAlign: 'left' }}><span id="spnStatus" style={{ color: 'Blue', fontWeight: 'bold' }}>{selectedLogin?.status}</span>&nbsp;/&nbsp;<span id="spnValidity" style={{ color: 'Blue', fontWeight: 'bold' }}>{formatValidityDate(selectedLogin?.validity || '')}</span></td>
                                </tr>
                                <tr>
                                  <td style={{ textAlign: 'left' }}>&nbsp;MDs Available:</td>
                                  <td style={{ textAlign: 'left' }}><span id="spnMDsAvail" style={{ color: 'Blue', fontWeight: 'bold' }}>{selectedLogin?.mdsAvail}</span></td>
                                </tr>
                                <tr>
                                  <td style={{ textAlign: 'left' }}>&nbsp;MDs Used:</td>
                                  <td style={{ textAlign: 'left' }}><span id="spnMdsUsed" style={{ color: 'Blue', fontWeight: 'bold' }}>{selectedLogin?.mdsUsed}</span></td>
                                </tr>
                                <tr style={{ borderTop: 'solid 1px blue', textAlign: 'left' }}>
                                  <td >&nbsp;GradeYear:</td>
                                  <td ><span id="spnGradeYear" style={{ color: 'Blue', fontWeight: 'bold' }}>{selectedChildLogin?.std}</span></td>
                                </tr>
                                <tr>
                                  <td style={{ textAlign: 'left' }}>&nbsp;Points:</td>
                                  <td style={{ textAlign: 'left' }}><span id="spnPoints" style={{ color: 'Blue', fontWeight: 'bold', padding: "0px" }}>{selectedChildLogin?.points}</span></td>
                                </tr>
                                <tr>
                                  <td style={{ textAlign: 'left' }}>&nbsp;Incentives:</td>
                                  <td style={{ textAlign: 'left' }}><span id="spnEligibleForIncentives" style={{ color: 'Blue', fontWeight: 'bold' }}>{selectedLogin?.incentives}</span></td>
                                </tr>
                                <tr>
                                  <td colSpan={2} style={{ borderTop: 'solid 1px blue', textAlign: 'left' }}>
                                    {canEditLogins && (
                                      <button style={{ height: '25px', width: '75px' }} className="cssButtonWithBorder" onClick={handleEditLogin}>Edit</button>
                                    )}
                                    {canLoginAs && (
                                      <button style={{ height: '25px', width: '75px' }} className="cssButtonWithBorder" onClick={handleGoLogin}>GO</button>
                                    )}
                                    {canViewLogins && (
                                      <button style={{ height: '25px', width: '95px' }} className="cssButtonWithBorder" onClick={() => navigate('/SUPPORT/EL_ViewLesson')}>View Lesson</button>
                                    )}
                                    {/* <button style={{height: '25px', width: '135px' }} className="cssButtonWithBorder" onClick={ () => navigate('/SUPPORT/EL_Questionperformance') }>Qn Performance</button> */}
                                    {/* <button style={{height: '25px', width: '145px' }} className="cssButtonWithBorder" onClick={ () => navigate('/SUPPORT/EL_Lessonperformance') }>Lesson Performance</button> */}
                                  </td>
                                </tr>
                                <button style={{ height: '20px', textAlign: 'center', color: 'black' }} onClick={handleShowWindowSize}>size</button>
                                <>{isDeveloperUser ? (<button style={{ height: '20px', marginLeft: '10px', textAlign: 'center', color: 'black' }} onClick={handleVMLogs}>VM Logs</button>) : null} </>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </center>

            {showAdminDiv && (
              <div id="divAdmin" style={{ position: 'absolute', display: 'block', border: 'solid 1px black', backgroundColor: 'white', zIndex: 1000 }}
                onMouseOver={(e) => handleDivOver(e.currentTarget)}
                onMouseOut={(e) => handleDivOut(e.currentTarget)}>
                {/* Admin menu items */}
              </div>
            )}
            {showSupportDiv && (
              <div id="divSupport" style={{ position: 'absolute', display: 'block', border: 'solid 1px black', backgroundColor: 'white', zIndex: 1000 }}
                onMouseOver={(e) => handleDivOver(e.currentTarget)}
                onMouseOut={(e) => handleDivOut(e.currentTarget)}>
                {/* Support menu items */}
              </div>
            )}
            {showReportsDiv && (
              <div id="divReports" style={{ position: 'absolute', display: 'block', border: 'solid 1px black', backgroundColor: 'white', zIndex: 1000 }}
                onMouseOver={(e) => handleDivOver(e.currentTarget)}
                onMouseOut={(e) => handleDivOut(e.currentTarget)}>
                {/* Reports menu items */}
              </div>
            )}
            {showDataDiv && (
              <div id="divData" style={{ position: 'absolute', display: 'block', border: 'solid 1px black', backgroundColor: 'white', zIndex: 1000 }}
                onMouseOver={(e) => handleDivOver(e.currentTarget)}
                onMouseOut={(e) => handleDivOut(e.currentTarget)}>
                {/* Data menu items */}
              </div>
            )}
            {showSuperAdminDiv && (
              <div id="divSuperAdmin" style={{ position: 'absolute', display: 'block', border: 'solid 1px black', backgroundColor: 'white', zIndex: 1000 }}
                onMouseOver={(e) => handleDivOver(e.currentTarget)}
                onMouseOut={(e) => handleDivOut(e.currentTarget)}>
                {/* SuperAdmin menu items */}
              </div>
            )}
            {showAnalysisDiv && (
              <div id="divAnalysis" style={{ position: 'absolute', display: 'block', border: 'solid 1px black', backgroundColor: 'white', zIndex: 1000, overflow: "visible" }}
                onMouseOver={(e) => handleDivOver(e.currentTarget)}
                onMouseOut={(e) => handleDivOut(e.currentTarget)}>
                {/* Analysis menu items */}
              </div>
            )}


            {(showAddDNC || showSearchDNC) && (
              <div style={{
                position: 'absolute',
                backgroundColor: 'rgb(204, 204, 204)',
                left: '0px',
                top: '0px',
                width: '100%',
                height: '911px',
                zIndex: 88888,
                opacity: 0.7
              }}></div>
            )}

            {showAddDNC && (
              <div style={{
                position: 'absolute',
                border: '1px solid black',
                backgroundColor: 'azure',
                width: '600px',
                height: '300px',
                zIndex: 99999,
                overflow: 'hidden',
                backgroundPositionY: 'center',
                left: '659px',
                top: '303px'
              }}>
                <EL_AddDNCNumbers mode="ADD" onClose={() => setShowAddDNC(false)} />
              </div>
            )}

            {showSearchDNC && (
              <div style={{
                position: 'absolute',
                border: '1px solid black',
                backgroundColor: 'azure',
                width: '800px',
                height: '906px',
                zIndex: 99999,
                overflow: 'hidden',
                backgroundPositionY: 'center',
                left: '559px',
                top: '0px'
              }}>
                <EL_AddDNCNumbers mode="SEARCH" onClose={() => setShowSearchDNC(false)} />
              </div>
            )}


            {alertInfo.show && (
              <CustomAlert
                message={alertInfo.message}
                onClose={() => setAlertInfo({ ...alertInfo, show: false })}
              />
            )}
            {confirmInfo.show && (
              <CustomConfirmation
                message={confirmInfo.message}
                onConfirm={confirmInfo.onConfirm}
                onClose={() => setConfirmInfo({ ...confirmInfo, show: false })}
              />
            )}

          </div>
        )}
    </>
  );
};

export default SysAdmin;